import React, { useEffect, useRef, useState } from "react";
import {
  Accordion,
  Button,
  Col,
  Container,
  Modal,
  Overlay,
  Row,
  Spinner,
  Tab,
  Table,
  Tabs,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { a11yDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import call from "../../assets/images/call.svg";
import deprecateIcon from "../../assets/images/Depricate.svg";
import discontinueIcon from "../../assets/images/Discontinue.svg";
import downloadIcon from "../../assets/images/download.svg";
import profilepic from "../../assets/images/dummy-profile-pic.jpg";
import dummyBanner from "../../assets/images/dummyBanner.png";
import editAction from "../../assets/images/editaction.svg";
import editPencil from "../../assets/images/editpencilIcon.svg";
import email from "../../assets/images/email.svg";
import annualsummary from "../../assets/images/My_machine.svg";
import DemoLogo from "../../assets/images/quantummain.svg";
import DemoLogoBig from "../../assets/images/MainLogoforMPD.svg";

import sminfo from "../../assets/images/sminfo.svg";
import {
  default as star,
  default as stars,
} from "../../assets/images/stars.svg";
import StopImg from "../../assets/images/stop.svg";
import updateIcon from "../../assets/images/Upgrade.svg";
import openeye from "../../assets/images/viewaction.svg";
import MachineModal from "../../Modals/MachineModal";
import MachineVersionModal from "../../Modals/MachineVersionModal";
import SubscriberTermsAndCondition from "../../Modals/SubscriberTermsAndCondition";
import TermsAndConditionInAll from "../../Modals/TermsAndConditionInAll";
import { commonservices, CountCharacter } from "../../services/CommonServices";
import { FaqGetList } from "../../services/ReduxTookit/Slice/MachineFaqRedux";
import {
  GetMachineDetailByPrimaryKey,
  GetMachineVersion,
  GetMachineVersionDetail,
  GetRepoFileContent,
  GetRepoStrcture,
  GetReviewerComment,
  GetSimilarMachineList,
  MachineRemoveFromLibrary,
  SaveMachineSubscriber,
  UpdateMachine,
  UpdateReviewComment,
} from "../../services/ReduxTookit/Slice/MachineRedux";
import BreadcrumbsNav from "../common-component/BreadcrumbsNav";
import FileStructure from "../common-component/FileStructure";
import Loader, { LoaderType } from "../common-component/Loader";
import Nodata from "../common-component/Nodata";
import StarRating from "../common-component/StarRating";
import InputDetail from "../ConfigurationComponent/InputDetail";
import BannerEdit from "../EditMarketPlaceDetails/BannerEdit";
import Classification from "../EditMarketPlaceDetails/Classification";
import CommentModal from "../EditMarketPlaceDetails/CommentModal";
import CompatibilityAndDependencies from "../EditMarketPlaceDetails/CompatibilityAndDependencies";
import FAQEditMarketplaceModal from "../EditMarketPlaceDetails/FAQEditMarketplaceModal";
import Overview from "../EditMarketPlaceDetails/Overview";
import ParameterEditMarketplaceModal from "../EditMarketPlaceDetails/ParameterEditMarketplaceModal";
import Specifications from "../EditMarketPlaceDetails/Specifications";
import SubmitLoading from "../common-component/Loaders/SubmitLoading";
import AddToCartModal from "../../Modals/AddToCart";
import {
  CartGetList,
  CartSave,
} from "../../services/ReduxTookit/Slice/CartRedux";
import ViewSimillar from "../ViewSimillar";
import WriteReviewModal from "../../Modals/WriteReviewModal";
import MainpageLoader from "../common-component/Loaders/MainpageLoader";
import { toast } from "react-toastify";
import {
  rejectFAQState,
  rejectParameterState,
} from "../../services/ReduxTookit/UserInfoSlice";
import AddToCartForAI from "../../Modals/AddToCartForAI";

function MarketPlaceDetailPopup(param) {
  let Userdata = useSelector(
    (state) => state?.userredux?.GetByPrimarykeyData?.data?.data?.data
  );
  // let param = useParams();
  const paramArray = useSelector(
    (state) => state?.userinfo?.RejectParametersData
  );
  const FAQListData = useSelector((state) => state?.userinfo?.RejectFAQData);
  let DevRoute = window.location.href.includes(`${process.env.REACT_APP_DEV}`);

  let navigate = useNavigate();
  let dispatch = useDispatch();
  const [fileContent, setFileContent] = useState(null);

  // const [UpdateResolveDetail, setUpdateResolveDetail] = useState("");
  const UpdateResolveDetail = useSelector(
    (state) =>
      state?.machineredux?.GetMachineVersionDetailData?.data?.data?.data
        ?.dataList1
  );

  const [TabState, setTabState] = useState("General Information");

  const [VersionState, setVersionState] = useState({
    machinename: "",
    number: "",
    status: "",
    date: "",
    action: "",
    reason: "",
    machineid: "",
    price: "",
  });

  const [UpdateReviewCommentData, setUpdateReviewCommentData] = useState({
    booleanfield: "",
    // booleanfieldvalue: null,
    commentfield: "",
    commentfieldvalue: "",
  });
  const [fileStructureLoading, setFileStructureLoading] = useState(false);
  const targetInputDetail = useRef();
  // const [MoreLessState, setMoreLessState] = useState(false);
  const [MoreLessState, setMoreLessState] = useState({
    flag: false,
    index: "",
  });
  const [showInputDetailPopup, setShowInputDetailPopu] = useState(false);
  const paraDetailRef = useRef();
  const [MachineVersionList, setMachineVersionList] = useState([]);

  const [RejectedVersionList, setRejectedVersionList] = useState([]);
  const [MachineVersionModalShow, setMachineVersionModalShow] = useState(false);
  const [MachineModalShow, setMachineModalShow] = useState(false);
  const [MachineModalType, setMachineModalType] = useState("");
  const [MachineModaldata, setMachineModaldata] = useState("");
  const [mainImage, setMainImage] = useState("");
  const [PurchaseLoader, setPurchaseLoader] = useState(false);
  const divRef = useRef(null);
  const [MachineDetailLoader, setMachineDetailLoader] = useState(false);
  const [FAQLoader, setFAQLoader] = useState(false);
  const [FAQList, setFAQList] = useState([]);
  const ScrollData = useRef(0);
  const [MachineDetails, setMachineDetails] = useState();

  const machineDetailRef = useRef();
  const [getEditStatus, setGetEditStatus] = useState();
  const [showSpecificationBtn, setShowSpecificationBtn] = useState(false);
  const [showSampleDataionBtn, setShowSampleDataBtn] = useState(false);
  const [showOverviewBtn, setShowOverViewBtn] = useState(false);
  const [showClassificationBtn, setShowClassificationBtn] = useState(false);
  const [showFAQBtn, setShowFAQBtn] = useState(false);
  const [showCompatibilityBtn, setShowCompatibilityBtn] = useState(false);
  const [showFaqModal, setShowFaqModal] = useState(false);
  const [fileContentLoading, setFileContentLoading] = useState(false);
  const [RejectDetailModalShow, setRejectDetailModalShow] = useState(false);
  const [fileStructure, setFileStructure] = useState(null);

  const [RejectDetailModaldata, setRejectDetailModaldata] = useState();
  const [selectedFile, setSelectedFile] = useState("");

  const [showBannerImageBtn, setShowBannerImageBtn] = useState(false);
  const [TandCShow, setTandCShow] = useState(false);
  const [addToCartShow, setAddToCartShow] = useState(false);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [Loading, setLoading] = useState(false);

  const closeReviewModal = () => {
    setShowReviewModal(false);
  };
  useEffect(() => {
    if (fileStructure) {
      setSelectedFile(fileStructure[0]?.name);
      handleFileSelection(fileStructure[0]?.name);
      getGitRepoFileContent(fileStructure[0]?.name);
    }
  }, [fileStructure]);
  const CartList = useSelector(
    (state) => state?.cartredux?.CartGetListData?.data?.data?.data
  );

  const GetCartLabel = () => {
    let a;
    if (VersionState?.machineid) {
      a = CartList?.find((item) => item?.machineid == VersionState?.machineid);
    }
    if (a) {
      return true;
    } else {
      return false;
    }
  };
  const GetRemoveFromLibrary = () => {
    if (
      MachineDetails?.dataList1[0]?.ispurchase &&
      !MachineDetails?.dataList1[0]?.ismainpurchase &&
      MachineDetails?.dataList1[0]?.isdisplayinlibrary
    ) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 105) {
        document.body.classList.add("scrolled");
        document.body.classList.add("sticky-panel");
      } else {
        document.body.classList.remove("scrolled");
        document.body.classList.remove("sticky-panel");
      }
    };

    // Ensure classes are reset on mount
    document.body.classList.remove("scrolled", "sticky-panel");

    // Check the current scroll position when component mounts
    handleScroll();

    // Add the scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
      // Remove the classes when component unmounts
      document.body.classList.remove("scrolled", "sticky-panel");
    };
  }, []); // Empty dependency array ensures this effect runs once

  const handlePlaceOrder = () => {
    let copyOfMachineDetails = { ...MachineDetails };
    copyOfMachineDetails.dataList1 = [...MachineDetails.dataList1];
    copyOfMachineDetails.dataList1[0] = {
      ...MachineDetails.dataList1[0],
      ispurchase: true,
    };
    setMachineDetails(copyOfMachineDetails);
  };

  const [similarMachineList, setSimilarMachineList] = useState(null);
  const [
    ParameterEditAddMachineModalShow,
    setParameterEditAddMachineModalShow,
  ] = useState(false);
  const [
    ParameterEditAddMachineModaltype,
    setParameterEditAddMachineModaltype,
  ] = useState("");
  const [Faqtype, setFaqtype] = useState("");
  const [ParameterEditAddSelectedData, setParameterEditAddSelectedData] =
    useState("");
  const [FAQEditAddSelectedData, setFAQEditAddSelectedData] = useState("");
  const [TermsAndPrivacyShow, setTermsAndPrivacyShow] = useState(false);
  const [TermsAndPrivacyType, setTermsAndPrivacyType] = useState(null);
  const gitFileApiCountRef = useRef(0);

  const gitRepoApiCountRef = useRef(0);
  const HandlePrivacyAndTerms = (type) => {
    setTermsAndPrivacyShow(true);
    setTermsAndPrivacyType(type);
  };
  const handleSpecificationClick = () => {
    setShowSpecificationBtn((s) => !s);
  };
  const handleOverviewClick = () => {
    setShowOverViewBtn((s) => !s);
  };
  const handleClassificationClick = () => {
    setShowClassificationBtn((s) => !s);
  };
  const handleCompatibilityClick = () => {
    setShowCompatibilityBtn((s) => !s);
  };
  const handleSampleDataClick = () => {
    setShowSampleDataBtn((s) => !s);
  };
  const handleBannerImageBtn = () => {
    setShowBannerImageBtn((s) => !s);
  };
  const handleOverlay = (e) => {
    let element = document.getElementById(e?.currentTarget?.id);
    if (element) {
      if (element.classList.contains("overlay-isopen")) {
        element.classList.remove("overlay-isopen");
      } else {
        element.classList.add("overlay-isopen");
      }
    }
  };
  const handleShowInputDetailPopup = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowInputDetailPopu(!showInputDetailPopup);
  };
  const [reviewWidths, setReviewWidths] = useState({
    total5start: "0",
    total4start: "0",
    total3start: "0",
    total2start: "0",
    total1start: "0",
  });

  const handleImageClick = (imageSrc) => {
    setMainImage(imageSrc);
  };
  const GetCartDetails = () => {
    dispatch(CartGetList({}));
  };
  useEffect(() => {
    if (VersionState?.machineid) {
      getGitRepoStructure();
    }
  }, [VersionState]);

  const getGitRepoStructure = async () => {
    setFileStructureLoading(true);
    let body = {
      machineid: VersionState?.machineid
        ? parseInt(VersionState?.machineid)
        : 0,
      versionnumber: VersionState?.number,
    };
    dispatch(GetRepoStrcture(body)).then((res) => {
      if (res?.payload?.isValidate) {
        let dataFromApi = res?.payload?.data?.data;

        function buildRepoHierarchy(data) {
          const root = [];

          // Helper function to find or create a folder in the current level
          function findOrCreateFolder(currentLevel, folderName) {
            let folder = currentLevel.find((item) => item.name === folderName);
            if (!folder) {
              folder = {
                type: "dir",
                name: folderName,
                path: folderName,
                child: [],
              };
              currentLevel.push(folder);
            }
            return folder;
          }

          // Helper function to insert a file or folder into the hierarchy
          function insertFile(pathParts, file) {
            let currentLevel = root;
            pathParts.forEach((part, index) => {
              if (index === pathParts.length - 1) {
                // If it's the last part, add the file
                currentLevel.push({
                  type: file.type,
                  name: file.name,
                  path: file.path,
                  child: [],
                });
              } else {
                // Otherwise, find or create the folder
                const folder = findOrCreateFolder(currentLevel, part);
                currentLevel = folder.child;
              }
            });
          }

          // Loop through each file/folder and insert it into the hierarchy
          data?.forEach((item) => {
            const pathParts = item.path.split("/");
            insertFile(pathParts, item);
          });

          return root;
        }

        // Get the repository hierarchy in the desired format
        const repoHierarchy = buildRepoHierarchy(dataFromApi?.structure);
        setFileStructure(repoHierarchy);
        setFileStructureLoading(false);
      }

      if (!res?.payload?.isValidate) {
        gitRepoApiCountRef.current = gitRepoApiCountRef.current + 1;
        setFileStructureLoading(false);
        if (gitRepoApiCountRef.current <= 1) {
          getGitRepoStructure();
        }
      }
    });
  };

  const SaveToCart = () => {
    let body = {
      associationid: parseInt(VersionState?.machineid),
      associationtype_term: "Machine",
      versionno: VersionState?.number,
      amount: VersionState?.price,
      categoryid: MachineDetails?.dataList1[0]?.categoryid,
    };
    dispatch(CartSave(body))?.then((res) => {
      if (res?.payload?.isValidate) {
        setAddToCartShow(true);
        GetCartDetails();
      }
    });
  };

  const AddtoLib = () => {
    let body = {
      machineid: parseInt(VersionState?.machineid),
      price: VersionState?.price,
      discount: 0,
      paidamount: VersionState?.price,
      innoofworkflow: 0,
    };
    dispatch(SaveMachineSubscriber(body)).then((res) => {
      if (res?.payload?.isValidate) {
        // GetCartDetails();
        getMachineDetails(VersionState?.machineid);
        GetCartDetails();
        getFAQList(VersionState?.machineid);
      }
    });
  };
  const RemoveFromLib = () => {
    dispatch(MachineRemoveFromLibrary(parseInt(VersionState?.machineid))).then(
      (res) => {
        if (res?.payload?.isValidate) {
          getMachineDetails(VersionState?.machineid);
          GetCartDetails();
          getFAQList(VersionState?.machineid);
        }
      }
    );
  };
  const getGitRepoFileContent = async (filePath) => {
    setSelectedFile(filePath);
    setFileContentLoading(true);
    let body = {
      machineid: VersionState?.machineid
        ? parseInt(VersionState?.machineid)
        : 0,
      versionnumber: VersionState?.number,
      fileurl: filePath,
    };
    dispatch(GetRepoFileContent(body)).then((res) => {
      if (res?.payload?.isValidate) {
        let dataFromApi = res?.payload?.data?.data;
        let getLng = dataFromApi?.path?.split(".");

        let groupingJson = {
          ...dataFromApi,
          language:
            getLng?.length > 1 ? getLng[getLng?.length - 1] : "Dockerfile",
        };
        setFileContent(groupingJson);
        setFileContentLoading(false);
      }
      if (!res?.payload?.isValidate) {
        gitFileApiCountRef.current = gitFileApiCountRef.current + 1;
        setFileContent(null);
        setFileContentLoading(false);
        if (gitFileApiCountRef.current <= 1) {
          getGitRepoFileContent();
        }
      }
    });
  };
  async function getMachineDetails(id) {
    setMachineDetailLoader(true);
    let body = {
      id: id,
    };
    dispatch(GetMachineDetailByPrimaryKey(body)).then((res) => {
      if (res?.payload?.isValidate) {
        machineDetailRef.current = {
          logo: res?.payload?.data?.data?.dataList1[0]?.machinelogo,
          name: res?.payload?.data?.data?.dataList1[0]?.machinename,
          version: "",
        };
        setMachineDetails(res?.payload?.data?.data);
        dispatch(rejectParameterState(res?.payload?.data?.data?.dataList3));
        setMainImage(res?.payload?.data?.data?.dataList5[0]?.bannerurl);
        setMachineDetailLoader(false);
      }
      if (!res?.payload?.isValidate) {
        setMachineDetailLoader(false);
      }
    });
  }
  async function getMachineVersions() {
    // setMachineDetailLoader(true);
    let body = {
      machineid:
        MachineDetails?.dataList1?.[0]?.refmachineid === 0
          ? MachineDetails?.dataList1?.[0]?.machineid
          : MachineDetails?.dataList1?.[0]?.refmachineid,
    };

    dispatch(GetMachineVersion(body)).then((res) => {
      if (res?.payload?.isValidate) {
        let allrejectedversion = res?.payload?.data?.data?.dataList1?.filter(
          (f) => f.status === "Rejected"
        );
        setRejectedVersionList(allrejectedversion);
        // let temp = res?.payload?.data?.data?.dataList1
        //   ?.slice(-1)
        //   ?.filter((f) => f.status === "Publish");
        let temp = res?.payload?.data?.data?.dataList1?.filter(
          (f) => f.status === "Publish"
        );

        let selectedVersion = res?.payload?.data?.data?.dataList1?.filter(
          (f) => f.machineid === MachineDetails?.dataList1?.[0]?.machineid
        );

        // setMachineVersionList(
        //   res?.payload?.data?.data?.dataList1?.filter((f) => f.status !== "Pending")
        // );
        setMachineVersionList(
          param?.pagename === "my machine"
            ? res?.payload?.data?.data?.dataList1
            : temp
        );
        if (param?.pagename === "my machine") {
          let data1 = res?.payload?.data?.data?.dataList1.slice(-1);
          setVersionState({
            machinename: selectedVersion?.[0]?.machinename,
            number: selectedVersion?.[0]?.versionnumber,
            status: selectedVersion?.[0]?.status,

            // status: selectedVersion?.[0]?.status,
            date: selectedVersion?.[0]?.isdiscontinued
              ? selectedVersion?.[0]?.discontinueddate
              : selectedVersion?.[0]?.isdeprecated
                ? selectedVersion?.[0]?.deprecateddate
                : "",
            action: selectedVersion?.[0]?.isdiscontinued
              ? "discontinued"
              : selectedVersion?.[0]?.isdeprecated
                ? "deprecating"
                : "",
            reason: selectedVersion?.[0]?.isdiscontinued
              ? selectedVersion?.[0]?.discontinuereason
              : selectedVersion?.[0]?.isdeprecated
                ? selectedVersion?.[0]?.deprecatedreason
                : selectedVersion?.[0]?.status === "Rejected"
                  ? selectedVersion?.[0]?.reviewreason
                  : "",
            // reason: selectedVersion?.[0]?.isdiscontinued
            //   ? selectedVersion?.[0]?.discontinuereason
            //   : selectedVersion?.[0]?.isdeprecated
            //   ? selectedVersion?.[0]?.deprecatedreason
            //   : "",
            machineid: selectedVersion?.[0]?.machineid,
            price: selectedVersion?.[0]?.price,
          });
        } else {
          setVersionState({
            machinename: selectedVersion?.[0]?.machinename,
            number: selectedVersion?.[0]?.versionnumber,
            // status: selectedVersion?.[0]?.status,
            status: selectedVersion?.[0]?.status,
            date: selectedVersion?.[0]?.isdiscontinued
              ? selectedVersion?.[0]?.discontinueddate
              : selectedVersion?.[0]?.isdeprecated
                ? selectedVersion?.[0]?.deprecateddate
                : "",
            action: selectedVersion?.[0]?.isdiscontinued
              ? "discontinued"
              : selectedVersion?.[0]?.isdeprecated
                ? "deprecating"
                : "",
            reason: selectedVersion?.[0]?.isdiscontinued
              ? selectedVersion?.[0]?.discontinuereason
              : selectedVersion?.[0]?.isdeprecated
                ? selectedVersion?.[0]?.deprecatedreason
                : "",
            machineid: selectedVersion?.[0]?.machineid,
            price: selectedVersion?.[0]?.price,
          });
        }

        // setVersionState
      }
      if (!res?.payload?.isValidate) {
      }
    });
  }

  const handleVersionClick = () => {
    setTabState("Version History");
    if (divRef.current) {
      divRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  async function getFAQList(id) {
    setFAQLoader(true);
    let body = {
      id: parseInt(id),
    };
    dispatch(FaqGetList(body))?.then((res) => {
      if (res?.payload?.isValidate) {
        setFAQLoader(false);
        setFAQList(res?.payload?.data?.data);
        dispatch(rejectFAQState(res?.payload?.data?.data));
      }
      if (!res?.payload?.isValidate) {
        setFAQLoader(false);
        setFAQList([]);
      }
    });
  }
  const getEditMachineData = async () => {
    let machineId = VersionState?.machineid
      ? parseInt(VersionState?.machineid)
      : 0;

    let versionNumber = VersionState?.number ? VersionState?.number : 0;
    // let versionNumber = MachineDetails?.dataList1?.[0]?.versionnumber
    //   ? MachineDetails.dataList1?.[0]?.versionnumber
    //   : 0;
    let body = {
      machineId: machineId,
      version: versionNumber,
    };

    dispatch(GetReviewerComment(body)).then((res) => {
      if (res?.payload?.isValidate) {
        setGetEditStatus(res?.payload?.data?.data);
      } else {
        setGetEditStatus([]);
      }
    });
  };

  const hasErrorInOverview = (title) => {
    if (title === "General Information") {
      return (
        getEditStatus?.machineoverview === false ||
        getEditStatus?.classification === false ||
        getEditStatus?.compatibility === false ||
        getEditStatus?.specification === false ||
        getEditStatus?.infrastructurereq === false ||
        getEditStatus?.bannerimage === false
      );
    } else if (title === "Parameters") {
      return getEditStatus?.parametersadded === false;
    } else if (title === "FAQs") {
      return getEditStatus?.faqadded === false;
    } else if (title === "Sample Data") {
      return getEditStatus?.specification === false;
    } else if (title === "Source Code") {
      return (
        getEditStatus?.codestructure === false ||
        getEditStatus?.codequality === false ||
        getEditStatus?.functionality === false ||
        getEditStatus?.security === false ||
        getEditStatus?.performance === false ||
        getEditStatus?.testingandcoverage === false ||
        getEditStatus?.compliancestandard === false ||
        getEditStatus?.mocktest === false
      );
    }
  };

  useEffect(() => {
    if (MachineDetails?.dataList2?.[0]) {
      const data = MachineDetails?.dataList2[0];
      const totalReviews =
        data["5star"] +
        data["4star"] +
        data["3star"] +
        data["2star"] +
        data["1star"];

      const calculateWidthPercentage = (count) => {
        if (totalReviews > 0 && count > 0) {
          return `${(count / totalReviews) * 100}`;
        }
        return "0";
      };
      setReviewWidths({
        total5start: calculateWidthPercentage(data["5star"]),
        total4start: calculateWidthPercentage(data["4star"]),
        total3start: calculateWidthPercentage(data["3star"]),
        total2start: calculateWidthPercentage(data["2star"]),
        total1start: calculateWidthPercentage(data["1star"]),
      });
    }
  }, [MachineDetails]);

  useEffect(() => {
    getMachineDetails(commonservices.bodyDecryption(param?.id));
    GetCartDetails();
    getFAQList(commonservices.bodyDecryption(param?.id));
    // getMachineVersions();
    window.scrollTo(0, 0);
  }, [param?.id]);

  useEffect(() => {
    if (
      MachineDetails?.dataList1?.[0]?.refmachineid ||
      MachineDetails?.dataList1?.[0]?.machineid
    ) {
      getMachineVersions();
    }
  }, [MachineDetails]);

  useEffect(() => {
    if (VersionState?.status === "Rejected") {
      getEditMachineData();
      // setParamArray(MachineDetails?.dataList3);
      // dispatch(rejectParameterState(MachineDetails?.dataList3))
    } else {
      setGetEditStatus();
    }
    if (VersionState?.machineid) {
      getMachineVersionDetail(VersionState?.machineid, VersionState?.number);
    }
  }, [VersionState]);

  const fnPurchase = async () => {
    setPurchaseLoader(true);
    let body = {
      machineid: VersionState?.machineid,
      price: VersionState?.price,
      discount: 0,
      paidamount: VersionState?.price,
      innoofworkflow: 0,
    };

    dispatch(SaveMachineSubscriber(body)).then((res) => {
      if (res?.payload?.isValidate) {
        if (param?.pagename === "my machine") {
          navigate("/machine");
        } else if (param?.pagename === "Marketplace") {
          navigate("/marketplace");
        }
        // navigate("/dashboard");
      }
      if (!res?.payload?.isValidate) {
      }
    });

    // ------------ Before Redux
    // let resData = await apiCall(
    //   {
    //     method: "POST",
    //     url: API_URL.BASEURL + API_URL.SAVE_MACHINE_SUBSCRIBER,
    //     body: body,
    //   },
    //   true
    // );
    // let response = apiResponse(true, resData, setPurchaseLoader);
    // if (response?.isValidate) {
    //   if (param?.pagename === "my machine") {
    //     navigate("/machine");
    //   } else if (param?.pagename === "Marketplace") {
    //     navigate("/marketplace");
    //   }
    //   // navigate("/dashboard");
    // }
    // if (!response?.isValidate) {
    // }
  };

  const handleFileSelection = (file) => {
    setSelectedFile(file);
  };
  const getSimilarMachineList = async (industryId, categoryId) => {
    let request = {
      industryId: industryId,
      categoryId: categoryId,
      id: commonservices.bodyDecryption(param?.id),
    };

    dispatch(GetSimilarMachineList(request)).then((res) => {
      if (res?.payload?.isValidate) {
        setSimilarMachineList(res?.payload?.data?.data);
      } else {
        setSimilarMachineList(null);
      }
    });
  };
  const getMachineVersionDetail = async (m_Id, v_no) => {
    let request = {
      m_Id: m_Id,
      v_no: v_no,
    };

    dispatch(GetMachineVersionDetail(request))?.then((res) => {
      if (res?.payload?.isValidate) {
        // setUpdateResolveDetail(res?.payload?.data?.data?.dataList1);
      }
      if (!res?.payload?.isValidate) {
        // setUpdateResolveDetail("");
      }
    });
  };

  useEffect(() => {
    if (
      MachineDetails?.dataList1?.[0]?.categoryid &&
      MachineDetails?.dataList1?.[0]?.industryid
    ) {
      getSimilarMachineList(
        MachineDetails?.dataList1?.[0]?.industryid,
        MachineDetails?.dataList1?.[0]?.categoryid
      );
    }
  }, [MachineDetails]);

  const updateReviewStatus = async (body) => {
    dispatch(UpdateReviewComment(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        getEditMachineData();
        getMachineVersions();
      }
      if (!response?.payload?.isValidate) {
      }
    });
  };

  const handleSubmit = async () => {
    let body = {
      machineid: MachineDetails?.dataList1?.[0]?.machineid,
      price: MachineDetails?.dataList1?.[0]?.price || 0,
      subcategoryid: MachineDetails?.dataList1?.[0]?.subcategoryid || 0,
      osrequirmet: MachineDetails?.dataList2?.[0]?.osrequirmet,
      storage: MachineDetails?.dataList2?.[0]?.storage,
      ram: MachineDetails?.dataList2?.[0]?.ram,
      cpu: MachineDetails?.dataList2?.[0]?.cpu,
      compatiblemachineids:
        MachineDetails?.dataList2?.[0]?.compatiblemachineids,
      dependentmachineids: MachineDetails?.dataList2?.[0]?.dependentmachineids,
      cloud: MachineDetails?.dataList2?.[0]?.cloud,
      machinefaqs: FAQList,
      status: countFalseValues() === 1 ? "In Process" : "Rejected",
    };
    dispatch(UpdateMachine(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        getGitRepoStructure();
        getMachineVersions();
        getEditMachineData();
        getMachineVersionDetail(VersionState?.machineid, VersionState?.number);
        setLoading(false);
      }
      if (!response?.payload?.isValidate) {
      }
    });
  };

  const updateReviewStatusForParameters = async (e, type) => {
    e.preventDefault();
    setLoading(true);
    let newbody = {
      machineid: VersionState?.machineid,
      versionnumber: VersionState?.number,
      booleanfield: UpdateReviewCommentData?.booleanfield,
      commentfield: UpdateReviewCommentData?.commentfield,
      commentfieldvalue: UpdateReviewCommentData?.commentfieldvalue,
    };
    dispatch(UpdateReviewComment(newbody))?.then((response) => {
      if (response?.payload?.isValidate) {
        if (type === "FAQ") {
          handleSubmit();
        } else {
          handleSubmitForParameters();
        }
      }
      if (!response?.payload?.isValidate) {
      }
    });
  };
  const countFalseValues = () => {
    return Object.values(getEditStatus).filter((value) => value === false)
      .length;
  };
  const handleSubmitForParameters = async (e) => {
    let body = {
      machineid: MachineDetails?.dataList1?.[0]?.machineid,
      price: MachineDetails?.dataList1?.[0]?.price || 0,
      subcategoryid: MachineDetails?.dataList1?.[0]?.subcategoryid || 0,
      osrequirmet: MachineDetails?.dataList2?.[0]?.osrequirmet,
      storage: MachineDetails?.dataList2?.[0]?.storage,
      ram: MachineDetails?.dataList2?.[0]?.ram,
      cpu: MachineDetails?.dataList2?.[0]?.cpu,
      compatiblemachineids:
        MachineDetails?.dataList2?.[0]?.compatiblemachineids,
      dependentmachineids: MachineDetails?.dataList2?.[0]?.dependentmachineids,
      cloud: MachineDetails?.dataList2?.[0]?.cloud,
      machineconfigparameter: MachineDetails?.dataList3,
      status: countFalseValues() === 1 ? "In Process" : "Rejected",
    };

    dispatch(UpdateMachine(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        getGitRepoStructure();
        getMachineVersions();
        getEditMachineData();
        getMachineVersionDetail(VersionState?.machineid, VersionState?.number);
        setLoading(false);
      }
      if (!response?.payload?.isValidate) {
      }
    });
  };

  //#region Close ToolTip / Overlays Outside Click ----------------------

  const overlayDesc_Ref = useRef(null);

  const handleOutsideClick = (event) => {
    if (
      overlayDesc_Ref.current &&
      !overlayDesc_Ref.current.contains(event.target) &&
      !targetInputDetail.current.contains(event.target)
    ) {
      handleShowInputDetailPopup(event); // Close the overlay
    }
  };
  useEffect(() => {
    if (param?.pagename === "my machine") {
      if (Userdata && MachineDetails) {
        if (
          Userdata?.subscriberid !== MachineDetails?.dataList1[0]?.subscriberid
        ) {
          toast.error("This machine does not belongs to you");
          navigate("/machine");
        }
      }
    }
  }, [param, MachineDetails, Userdata]);

  useEffect(() => {
    if (showInputDetailPopup) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showInputDetailPopup]);

  //#endregion ----------------------
  return (
    <Modal
      {...param}
      // size="fullscreen"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen
      scrollable
      className="marketplace-modal"
    >
      {" "}
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Marketplace
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="dashboard-main market-place-page-main market-place-detail-page-main mymachine-page-detail">
          {(PurchaseLoader || Loading) && <MainpageLoader />}
          <div className="all-page-top pb-0">
            <Container>
              <div className="top-section-all d-block">
                <div className="top-section-left">
                  {/* <BreadcrumbsNav pageNav={BreadcrumbSingle} /> */}
                  {MachineDetailLoader ? (
                    <Loader type={LoaderType.MarketHeader} count={1} />
                  ) : (
                    <div className="d-flex align-items-center justify-content-between w-100 mb40 mymachine-detail-title">
                      <div className="top-left-sect-detail marketplace-profile-image">
                        <div
                          // className="top-left-sect-detail-img"
                          className={`single-market-place-img ${param?.pagename === "my machine"
                            ? commonservices.MachineStatus(
                              VersionState?.status
                            )
                            : ""
                            }`}
                        >
                          <img
                            src={
                              MachineDetails?.dataList1[0]?.machinelogo !==
                                "" &&
                                MachineDetails?.dataList1[0]?.machinelogo !== null
                                ? MachineDetails?.dataList1[0]?.machinelogo
                                : DemoLogo
                            }
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null;
                              currentTarget.src = DemoLogo;
                            }}
                            alt="marketplace"
                          />
                        </div>
                        <div className="top-left-sect-detail-content">
                          <div className="title-rating">
                            <h5>{MachineDetails?.dataList1[0]?.machinename}</h5>
                            {/* {MachineDetails?.dataList4[0]?.avgrating > 0 && (
                          <div className="rating-main">
                            <img src={star} alt="star" />
                            <p>
                              {MachineDetails?.dataList4[0]?.avgrating?.toFixed(
                                1
                              )}
                            </p>
                          </div>
                        )} */}
                            <div
                              className="version-name cursor-pointer"
                              onClick={handleVersionClick}
                            >
                              {VersionState?.number}
                              {/* <span className="grey-badge ms-2">
                            {VersionState?.status}
                          </span> */}
                            </div>
                            <div className="title-rating mt-2     justify-content-center">
                              {/* {MachineDetails?.dataList2[0]?.averagerating > 0 && ( */}
                              <div className="rating-main">
                                <img src={star} alt="star" />
                                <p>
                                  {MachineDetails?.dataList2[0]?.averagerating?.toFixed(
                                    1
                                  ) || 0}
                                </p>
                              </div>
                              {/* )} */}
                            </div>
                          </div>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: MachineDetails?.dataList2[0]
                                ?.shortdescription
                                ? commonservices.truncateText(
                                  commonservices.stripHTML(
                                    MachineDetails?.dataList2[0]
                                      ?.shortdescription
                                  ),
                                  CountCharacter.MarketPlaceShortDetail
                                )
                                : "",
                            }}
                          />
                        </div>
                      </div>
                      <div className="top-section-right marketdetail-one">
                        <h5>
                          {/* {MachineDetails?.dataList1[0]?.price > 0
                        ?  */}
                          {VersionState?.price > 0
                            ? "$" + VersionState?.price?.toFixed(2)
                            : "Free"}
                          {/* : ""} */}
                        </h5>

                        {parseInt(Userdata?.subscriberid) ===
                          parseInt(
                            MachineDetails?.dataList1?.[0]?.subscriberid
                          ) && param?.pagename === "my machine" ? (
                          <>
                            <Button
                              className="green-btn d-inline-block cursor-pointer"
                              onClick={(e) =>
                                navigate(
                                  `/marketplace/addMachine/${commonservices.bodyEncryption(
                                    String(
                                      MachineDetails?.dataList1?.[0]
                                        ?.refmachineid === 0
                                        ? MachineDetails?.dataList1?.[0]
                                          ?.machineid
                                        : MachineDetails?.dataList1?.[0]
                                          ?.refmachineid
                                    )
                                  )}`
                                )
                              }
                            >
                              Upgrade
                            </Button>
                            {/* )} */}
                          </>
                        ) : (
                          parseInt(Userdata?.subscriberid) !==
                          parseInt(
                            MachineDetails?.dataList1?.[0]?.subscriberid
                          ) && (
                            <>
                              {param?.pagename === "Marketplace" &&
                                MachineDetails?.dataList1[0]?.ispurchable ===
                                true ? (
                                <>
                                  {DevRoute ? (
                                    <></>
                                  ) : (
                                    <Button
                                      disabled={
                                        PurchaseLoader ||
                                          (MachineDetails?.dataList1[0]
                                            ?.ispurchase &&
                                            MachineDetails?.dataList1[0]
                                              ?.ismainpurchase) ||
                                          Userdata?.subscriberid ===
                                          MachineDetails?.dataList1[0]
                                            ?.subscriberid
                                          ? true
                                          : GetCartLabel()
                                            ? true
                                            : false
                                      }
                                      className={`blue-btn d-inline-block cursor-pointer ${PurchaseLoader ||
                                        (MachineDetails?.dataList1[0]
                                          ?.ispurchase &&
                                          MachineDetails?.dataList1[0]
                                            ?.ismainpurchase) ||
                                        Userdata?.subscriberid ===
                                        MachineDetails?.dataList1[0]
                                          ?.subscriberid
                                        ? "disabled-btn"
                                        : ""
                                        } `}
                                      onClick={() => {
                                        if (
                                          !MachineDetails?.dataList1[0]
                                            ?.ispurchase &&
                                          !MachineDetails?.dataList1[0]
                                            ?.ismainpurchase
                                        ) {
                                          //regular purchase

                                          SaveToCart();
                                        } else if (
                                          MachineDetails?.dataList1[0]
                                            ?.ispurchase &&
                                          !MachineDetails?.dataList1[0]
                                            ?.ismainpurchase &&
                                          !MachineDetails?.dataList1[0]
                                            ?.isdisplayinlibrary
                                        ) {
                                          //add to library

                                          AddtoLib();
                                        } else if (
                                          MachineDetails?.dataList1[0]
                                            ?.ispurchase &&
                                          !MachineDetails?.dataList1[0]
                                            ?.ismainpurchase &&
                                          MachineDetails?.dataList1[0]
                                            ?.isdisplayinlibrary
                                        ) {
                                          // "Remove from library"

                                          RemoveFromLib();
                                        }
                                      }}
                                    >
                                      {PurchaseLoader ? (
                                        <SubmitLoading />
                                      ) : (
                                        <>
                                          {MachineDetails?.dataList1[0]
                                            ?.ispurchase &&
                                            MachineDetails?.dataList1[0]
                                              ?.ismainpurchase ? (
                                            <>
                                              {" "}
                                              {(MachineDetails?.dataList1[0]
                                                ?.ispurchase &&
                                                MachineDetails?.dataList1[0]
                                                  ?.ismainpurchase) ||
                                                Userdata?.subscriberid ===
                                                MachineDetails?.dataList1[0]
                                                  ?.subscriberid
                                                ? "Purchased"
                                                : GetCartLabel()
                                                  ? "Added to cart"
                                                  : "Purchase"}
                                            </>
                                          ) : (
                                            <>
                                              {" "}
                                              {(MachineDetails?.dataList1[0]
                                                ?.ispurchase &&
                                                !MachineDetails?.dataList1[0]
                                                  ?.ismainpurchase &&
                                                !MachineDetails?.dataList1[0]
                                                  ?.isdisplayinlibrary) ||
                                                Userdata?.subscriberid ===
                                                MachineDetails?.dataList1[0]
                                                  ?.subscriberid
                                                ? "Add to library"
                                                : GetCartLabel()
                                                  ? "Added to cart"
                                                  : GetRemoveFromLibrary()
                                                    ? "Remove from library"
                                                    : "Purchase"}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </Button>
                                  )}
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          )
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Container>
          </div>
          <div className="main-page-content profilecomplate-common mt-0">
            <Container>
              <div className="all-marketplace-wrapper tabbing-action">
                <Row className="all-marketplace-wrapper-grid">
                  {MachineDetailLoader ? (
                    <Loader type={LoaderType.MarketMainLeft} />
                  ) : (
                    <Col
                      xl={9}
                      className="all-marketplace-main-content"
                      ref={divRef}
                    >
                      <div className="parentstickey">
                        <div className="tabin-title tabborder position-relative">
                          <div className="tabing-custom position-absolute top-0">
                            {TabState}
                          </div>
                          <div className="mysticketab">
                            <Tabs
                              activeKey={TabState}
                              id="uncontrolled-tab-example"
                              className="mb-3 custom-tabing markettabing-data sticktabmarket"
                              fill
                              onSelect={(e) => {
                                if (
                                  e === "Source Code" &&
                                  hasErrorInOverview("Source Code")
                                ) {
                                  if (
                                    !hasErrorInOverview(
                                      "General Information"
                                    ) &&
                                    !hasErrorInOverview("Sample Data") &&
                                    !hasErrorInOverview("FAQs") &&
                                    !hasErrorInOverview("Parameters")
                                  ) {
                                    setTabState(e);
                                    setSelectedFile(
                                      fileStructure && fileStructure[0]?.name
                                    );
                                    handleFileSelection(fileStructure[0]?.name);
                                    getGitRepoFileContent(
                                      fileStructure[0]?.name
                                    );
                                  } else {
                                    toast.error(
                                      "First complete all other rejected details"
                                    );
                                  }
                                } else {
                                  setTabState(e);

                                  if (fileStructure && e === "Source Code") {
                                    setSelectedFile(
                                      fileStructure && fileStructure[0]?.name
                                    );
                                    handleFileSelection(fileStructure[0]?.name);
                                    getGitRepoFileContent(
                                      fileStructure[0]?.name
                                    );
                                  }
                                }
                              }}
                            >
                              <Tab
                                eventKey="General Information"
                                className="mystickcontenttab"
                                title={
                                  <span
                                    style={{
                                      color: hasErrorInOverview(
                                        "General Information"
                                      )
                                        ? "red"
                                        : "inherit",
                                    }}
                                  >
                                    General Information
                                  </span>
                                }
                              >
                                <div className="key-benifits-main">
                                  <div className="all-report-images">
                                    {/* {VersionState?.status === "Rejected" && ( */}
                                    {param?.pagename === "my machine" &&
                                      RejectedVersionList?.length > 0 &&
                                      RejectedVersionList?.map(
                                        (item_r, index_r) => (
                                          <div
                                            key={index_r}
                                            className="machinewarning machinewarning-left d-flex align-items-center gap-2 justify-content-between"
                                          >
                                            <div className="d-flex warninginner">
                                              <div>
                                                <img src={StopImg} alt="stop" />
                                              </div>
                                              <div>
                                                {" "}
                                                <h5>
                                                  {item_r?.machinename} v
                                                  <span className="red-font-color">
                                                    {item_r?.versionnumber}{" "}
                                                  </span>
                                                  is {item_r?.status} due to
                                                  false details and errors
                                                </h5>
                                                <p>
                                                  {commonservices.truncateText(
                                                    item_r?.reviewreason,
                                                    CountCharacter.RejectedComment
                                                  )}
                                                </p>
                                              </div>
                                            </div>
                                            <button
                                              onClick={(e) => {
                                                e.preventDefault();
                                                setVersionState({
                                                  machinename:
                                                    item_r?.machinename,
                                                  number: item_r?.versionnumber,
                                                  status: item_r?.status,
                                                  date: item_r?.isdiscontinued
                                                    ? item_r?.discontinueddate
                                                    : item_r?.isdeprecated
                                                      ? item_r?.deprecateddate
                                                      : "",
                                                  action: item_r?.isdiscontinued
                                                    ? "discontinued"
                                                    : item_r?.isdeprecated
                                                      ? "deprecating"
                                                      : "",
                                                  reason: item_r?.isdiscontinued
                                                    ? item_r?.discontinuereason
                                                    : item_r?.isdeprecated
                                                      ? item_r?.deprecatedreason
                                                      : "",
                                                  machineid: item_r?.machineid,
                                                  price: item_r?.price,
                                                });
                                                getMachineDetails(
                                                  item_r?.machineid
                                                );
                                                getFAQList(item_r?.machineid);
                                              }}
                                              className="red-btn w-auto"
                                            >
                                              Fix Now
                                            </button>
                                          </div>
                                        )
                                      )}
                                    {/* )} */}
                                    <div
                                      className={
                                        VersionState?.status === "Rejected" &&
                                        getEditStatus?.bannerimage === false &&
                                        "red-bordered-box"
                                      }
                                    >
                                      {VersionState?.status === "Rejected" &&
                                        getEditStatus?.bannerimage === false &&
                                        !showBannerImageBtn ? (
                                        <>
                                          <div className="d-flex align-items-center gap-2 justify-content-end mb12">
                                            <button
                                              className="red-btn sm-red-btn w-auto"
                                              onClick={(e) => {
                                                setRejectDetailModalShow(true);
                                                setRejectDetailModaldata(
                                                  getEditStatus?.bannerimagecomment ||
                                                  ""
                                                );
                                              }}
                                            >
                                              <span>
                                                <img
                                                  src={openeye}
                                                  alt="comment"
                                                  className="cursor-pointer"
                                                />
                                              </span>
                                              <span>Comment</span>
                                            </button>

                                            <button
                                              className="black-btn sm-black-btn  w-auto"
                                              onClick={() => {
                                                handleBannerImageBtn();
                                                setUpdateReviewCommentData({
                                                  ...UpdateReviewCommentData,
                                                  booleanfield: "bannerimage",
                                                  commentfield:
                                                    "bannerimagecomment",
                                                  commentfieldvalue:
                                                    getEditStatus?.bannerimagecomment,
                                                });
                                              }}
                                            >
                                              <span>
                                                <img
                                                  src={editPencil}
                                                  alt="editmachineOverview"
                                                />
                                              </span>
                                              <span>Edit</span>
                                            </button>
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {VersionState?.status === "Rejected" &&
                                        getEditStatus?.bannerimage === false &&
                                        showBannerImageBtn ? (
                                        <BannerEdit
                                          getlist={MachineDetails}
                                          machineId={
                                            MachineDetails?.dataList1[0]
                                              ?.machineid
                                          }
                                          // bindlist={getMachineDetails}
                                          bindlist={getEditMachineData}
                                          versionlist={VersionState}
                                          updatereviewcommentdata={
                                            UpdateReviewCommentData
                                          }
                                          geteditstatus={getEditStatus}
                                          setmainimage={setMainImage}
                                          handleclose={() =>
                                            handleBannerImageBtn()
                                          }
                                          setmachinedetails={setMachineDetails}
                                        />
                                      ) : (
                                        <>
                                          <img
                                            src={
                                              mainImage
                                                ? mainImage
                                                : DemoLogoBig
                                            }
                                            alt="annualsummary1"
                                            className="main-big-img"
                                            onError={({ currentTarget }) => {
                                              currentTarget.onerror = null;
                                              currentTarget.src = DemoLogoBig;
                                            }}
                                          />
                                          <div className="smaller-size-images">
                                            {MachineDetails?.dataList5?.length >
                                              0 &&
                                              MachineDetails?.dataList5?.map(
                                                (item_d5, index_d5) => (
                                                  <React.Fragment
                                                    key={index_d5}
                                                  >
                                                    <img
                                                      src={
                                                        item_d5?.thumbnailurl ||
                                                        DemoLogo
                                                      }
                                                      alt="annualsummary1"
                                                      className={
                                                        mainImage ===
                                                          item_d5?.thumbnailurl
                                                          ? "smaller-size-img active"
                                                          : "smaller-size-img"
                                                      }
                                                      onError={({
                                                        currentTarget,
                                                      }) => {
                                                        currentTarget.onerror =
                                                          null;
                                                        currentTarget.src =
                                                          DemoLogo;
                                                      }}
                                                      onClick={() =>
                                                        handleImageClick(
                                                          item_d5?.bannerurl
                                                        )
                                                      }
                                                    />
                                                  </React.Fragment>
                                                )
                                              )}
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                  <div
                                    className={
                                      VersionState?.status === "Rejected" &&
                                      getEditStatus?.machineoverview ===
                                      false &&
                                      "red-bordered-box"
                                    }
                                  >
                                    <div className="machine-edit">
                                      <h4>Machine Overview</h4>
                                      {VersionState?.status === "Rejected" &&
                                        getEditStatus?.machineoverview ===
                                        false &&
                                        !showOverviewBtn ? (
                                        <div className="d-flex align-items-center gap-2 justify-content-end">
                                          <button
                                            className="red-btn sm-red-btn w-auto"
                                            onClick={(e) => {
                                              setRejectDetailModalShow(true);
                                              setRejectDetailModaldata(
                                                getEditStatus?.machineoverviewcomment
                                              );
                                            }}
                                          >
                                            <span>
                                              <img
                                                src={openeye}
                                                alt="comment"
                                                className="cursor-pointer"
                                              />
                                            </span>
                                            <span>Comment</span>
                                          </button>

                                          <button
                                            className="black-btn sm-black-btn w-auto"
                                            onClick={() => {
                                              handleOverviewClick();
                                              setUpdateReviewCommentData({
                                                ...UpdateReviewCommentData,
                                                booleanfield: "machineoverview",
                                                commentfield:
                                                  "machineoverviewcomment",
                                                commentfieldvalue:
                                                  getEditStatus?.machineoverviewcomment,
                                              });
                                            }}
                                          >
                                            <span>
                                              <img
                                                src={editPencil}
                                                alt="editmachineOverview"
                                              />
                                            </span>
                                            <span>Edit</span>
                                          </button>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    {VersionState?.status === "Rejected" &&
                                      getEditStatus?.machineoverview === false &&
                                      showOverviewBtn ? (
                                      <Overview
                                        getlist={MachineDetails}
                                        machineId={
                                          MachineDetails?.dataList1[0]
                                            ?.machineid
                                        }
                                        handleclose={handleOverviewClick}
                                        // bindlist={getMachineDetails}
                                        bindlist={getEditMachineData}
                                        versionlist={VersionState}
                                        updatereviewcommentdata={
                                          UpdateReviewCommentData
                                        }
                                        geteditstatus={getEditStatus}
                                        setmachinedetails={setMachineDetails}
                                      />
                                    ) : (
                                      <ul>
                                        <li>
                                          <strong>Machine Name : </strong>
                                          {MachineDetails?.dataList1[0]
                                            ?.machinename
                                            ? MachineDetails?.dataList1[0]
                                              ?.machinename
                                            : " - "}
                                        </li>
                                        <li>
                                          <strong>Title : </strong>
                                          {MachineDetails?.dataList2[0]?.title
                                            ? MachineDetails?.dataList2[0]
                                              ?.title
                                            : " - "}
                                        </li>
                                        <li>
                                          <strong>Short Description : </strong>
                                          {MachineDetails?.dataList2[0]
                                            ?.shortdescription ? (
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  MachineDetails?.dataList2[0]
                                                    ?.shortdescription,
                                              }}
                                            />
                                          ) : (
                                            "  - "
                                          )}
                                        </li>
                                        <li>
                                          <strong>Detail Description : </strong>
                                          {MachineDetails?.dataList2[0]
                                            ?.detaildescription ? (
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  MachineDetails?.dataList2[0]
                                                    ?.detaildescription,
                                              }}
                                            />
                                          ) : (
                                            "  - "
                                          )}
                                        </li>
                                        <li>
                                          <div className="d-flex align-items-center gap-2 mb-1">
                                            <strong>Machine Document : </strong>
                                            {MachineDetails?.dataList1[0]
                                              ?.documentpathurl ? (
                                              <Link
                                                target="_blank"
                                                className="theme-color-text"
                                                to={
                                                  MachineDetails?.dataList1[0]
                                                    ?.documentpathurl
                                                }
                                              >
                                                <span className="input-download-icon">
                                                  <img
                                                    src={downloadIcon}
                                                    alt="downloadIcon"
                                                  />
                                                  Download
                                                </span>
                                              </Link>
                                            ) : (
                                              "-"
                                            )}
                                          </div>
                                        </li>
                                      </ul>
                                    )}
                                  </div>
                                </div>
                                <div
                                  className={
                                    VersionState?.status === "Rejected" &&
                                    getEditStatus?.classification === false &&
                                    "red-bordered-box"
                                  }
                                >
                                  <div className="key-benifits-main">
                                    <div className="machine-edit">
                                      <h4>Classification</h4>
                                      {VersionState?.status === "Rejected" &&
                                        getEditStatus?.classification === false &&
                                        !showClassificationBtn ? (
                                        <>
                                          <div className="d-flex align-items-center gap-2 justify-content-end mb12">
                                            <button
                                              className="red-btn sm-red-btn w-auto"
                                              onClick={(e) => {
                                                setRejectDetailModalShow(true);
                                                setRejectDetailModaldata(
                                                  getEditStatus?.classificationcomment ||
                                                  ""
                                                );
                                              }}
                                            >
                                              <span>
                                                <img
                                                  src={openeye}
                                                  alt="comment"
                                                  className="cursor-pointer"
                                                />
                                              </span>
                                              <span>Comment</span>
                                            </button>
                                            <button
                                              className="black-btn sm-black-btn  w-auto"
                                              onClick={() => {
                                                handleClassificationClick();
                                                setUpdateReviewCommentData({
                                                  ...UpdateReviewCommentData,
                                                  booleanfield:
                                                    "classification",
                                                  commentfield:
                                                    "classificationcomment",
                                                  commentfieldvalue:
                                                    getEditStatus?.classificationcomment,
                                                });
                                              }}
                                            >
                                              <span>
                                                <img
                                                  src={editPencil}
                                                  alt="editmachineOverview"
                                                />
                                              </span>
                                              <span>Edit</span>
                                            </button>
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    {VersionState?.status === "Rejected" &&
                                      getEditStatus?.classification === false &&
                                      showClassificationBtn ? (
                                      <Classification
                                        getlist={MachineDetails}
                                        machineId={
                                          MachineDetails?.dataList1[0]
                                            ?.machineid
                                        }
                                        handleclose={handleClassificationClick}
                                        // bindlist={getMachineDetails}
                                        bindlist={getEditMachineData}
                                        versionlist={VersionState}
                                        updatereviewcommentdata={
                                          UpdateReviewCommentData
                                        }
                                        geteditstatus={getEditStatus}
                                        setmachinedetails={setMachineDetails}
                                      />
                                    ) : (
                                      <ul>
                                        <li>
                                          <strong>Industry : </strong>
                                          {MachineDetails?.dataList1[0]
                                            ?.industryname ? (
                                            <strong className="theme-color-text ps-1">
                                              {
                                                MachineDetails?.dataList1[0]
                                                  ?.industryname
                                              }
                                            </strong>
                                          ) : (
                                            " - "
                                          )}
                                        </li>
                                        <li>
                                          <strong>Category : </strong>
                                          {MachineDetails?.dataList1[0]
                                            ?.categoryname
                                            ? MachineDetails?.dataList1[0]
                                              ?.categoryname
                                            : " - "}
                                        </li>
                                        <li>
                                          <strong>Sub Category : </strong>
                                          {MachineDetails?.dataList1[0]
                                            ?.subcategoryname
                                            ? MachineDetails?.dataList1[0]
                                              ?.subcategoryname
                                            : " - "}
                                        </li>
                                      </ul>
                                    )}
                                  </div>
                                </div>
                                <div
                                  className={
                                    VersionState?.status === "Rejected" &&
                                    getEditStatus?.compatibility === false &&
                                    "red-bordered-box"
                                  }
                                >
                                  <div className="key-benifits-main">
                                    <div className="machine-edit">
                                      <h4>Compatibility And Dependencies</h4>
                                      {VersionState?.status === "Rejected" &&
                                        getEditStatus?.compatibility === false &&
                                        !showCompatibilityBtn ? (
                                        <>
                                          <div className="d-flex align-items-center gap-2 justify-content-end mb12">
                                            <button
                                              className="red-btn sm-red-btn w-auto"
                                              onClick={(e) => {
                                                setRejectDetailModalShow(true);
                                                setRejectDetailModaldata(
                                                  getEditStatus?.compatibilitycomment ||
                                                  ""
                                                );
                                              }}
                                            >
                                              <span>
                                                <img
                                                  src={openeye}
                                                  alt="comment"
                                                  className="cursor-pointer"
                                                />
                                              </span>
                                              <span>Comment</span>
                                            </button>

                                            <button
                                              className="black-btn sm-black-btn  w-auto"
                                              onClick={() => {
                                                handleCompatibilityClick();
                                                setUpdateReviewCommentData({
                                                  ...UpdateReviewCommentData,
                                                  booleanfield: "compatibility",
                                                  commentfield:
                                                    "compatibilitycomment",
                                                  commentfieldvalue:
                                                    getEditStatus?.compatibilitycomment,
                                                });
                                              }}
                                            >
                                              <span>
                                                <img
                                                  src={editPencil}
                                                  alt="editmachineOverview"
                                                />
                                              </span>
                                              <span>Edit</span>
                                            </button>
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    {VersionState?.status === "Rejected" &&
                                      getEditStatus?.compatibility === false &&
                                      showCompatibilityBtn ? (
                                      <CompatibilityAndDependencies
                                        getlist={MachineDetails}
                                        machineId={
                                          MachineDetails?.dataList1[0]
                                            ?.machineid
                                        }
                                        handleclose={handleCompatibilityClick}
                                        // bindlist={getMachineDetails}
                                        bindlist={getEditMachineData}
                                        versionlist={VersionState}
                                        updatereviewcommentdata={
                                          UpdateReviewCommentData
                                        }
                                        geteditstatus={getEditStatus}
                                        setmachinedetails={setMachineDetails}
                                      />
                                    ) : (
                                      <ul>
                                        <li>
                                          <strong>
                                            Preferred Dependent Machines :{" "}
                                          </strong>
                                          {MachineDetails?.dataList2[0]
                                            ?.dependentmachines ? (
                                            <span className="theme-color-text">
                                              {
                                                MachineDetails?.dataList2[0]
                                                  ?.dependentmachines
                                              }
                                            </span>
                                          ) : (
                                            " - "
                                          )}
                                        </li>
                                        <li>
                                          <strong>
                                            Compatible Machines :{" "}
                                          </strong>
                                          {MachineDetails?.dataList2[0]
                                            ?.compatiblemachines
                                            ? MachineDetails?.dataList2[0]
                                              ?.compatiblemachines
                                            : " - "}
                                        </li>
                                        <li>
                                          <strong>Version : </strong>
                                          {MachineDetails?.dataList1[0]
                                            ?.versionnumber
                                            ? MachineDetails?.dataList1[0]
                                              ?.versionnumber
                                            : " - "}
                                        </li>
                                      </ul>
                                    )}
                                  </div>
                                </div>
                                <div
                                  className={
                                    VersionState?.status === "Rejected" &&
                                    getEditStatus?.specification === false &&
                                    "red-bordered-box"
                                  }
                                >
                                  <div className="key-benifits-main">
                                    <div className="machine-edit">
                                      <h4>Specifications</h4>
                                      {VersionState?.status === "Rejected" &&
                                        getEditStatus?.specification === false &&
                                        !showSpecificationBtn ? (
                                        <>
                                          <div className="d-flex align-items-center gap-2 justify-content-end mb12">
                                            <button
                                              className="red-btn sm-red-btn w-auto"
                                              onClick={(e) => {
                                                setRejectDetailModalShow(true);
                                                setRejectDetailModaldata(
                                                  getEditStatus?.specificationcomment ||
                                                  ""
                                                );
                                              }}
                                            >
                                              <span>
                                                <img
                                                  src={openeye}
                                                  alt="comment"
                                                  className="cursor-pointer"
                                                />
                                              </span>
                                              <span>Comment</span>
                                            </button>

                                            <button
                                              className="black-btn sm-black-btn  w-auto"
                                              onClick={() => {
                                                handleSpecificationClick();
                                                setUpdateReviewCommentData({
                                                  ...UpdateReviewCommentData,
                                                  booleanfield: "specification",
                                                  commentfield:
                                                    "specificationcomment",
                                                  commentfieldvalue:
                                                    getEditStatus?.specificationcomment,
                                                });
                                              }}
                                            >
                                              <span>
                                                <img
                                                  src={editPencil}
                                                  alt="editmachineOverview"
                                                />
                                              </span>
                                              <span>Edit</span>
                                            </button>
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    {VersionState?.status === "Rejected" &&
                                      getEditStatus?.specification === false &&
                                      showSpecificationBtn ? (
                                      <Specifications
                                        getlist={MachineDetails}
                                        machineId={
                                          MachineDetails?.dataList1[0]
                                            ?.machineid
                                        }
                                        handleclose={handleSpecificationClick}
                                        // bindlist={getMachineDetails}
                                        versionlist={VersionState}
                                        updatereviewcommentdata={
                                          UpdateReviewCommentData
                                        }
                                        geteditstatus={getEditStatus}
                                        setmachinedetails={setMachineDetails}
                                      />
                                    ) : (
                                      <ul>
                                        <li>
                                          <div className="d-flex align-items-center gap-2 mb-1">
                                            <strong>
                                              Input Specifications :{" "}
                                            </strong>
                                            {MachineDetails?.dataList1[0]
                                              ?.inputsamplefileurl && (
                                                <Link
                                                  target="_blank"
                                                  className="theme-color-text"
                                                  to={
                                                    MachineDetails?.dataList1[0]
                                                      ?.inputsamplefileurl
                                                  }
                                                >
                                                  <span className="input-download-icon">
                                                    <img
                                                      src={downloadIcon}
                                                      alt="downloadIcon"
                                                    />
                                                    Download
                                                  </span>
                                                </Link>
                                              )}
                                          </div>

                                          {MachineDetails?.dataList2[0]
                                            ?.inputdescription ? (
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  MachineDetails?.dataList2[0]
                                                    ?.inputdescription,
                                              }}
                                            />
                                          ) : (
                                            " - "
                                          )}
                                        </li>
                                        <li>
                                          <div className="d-flex align-items-center gap-2 mb-1">
                                            <strong>
                                              Output Specifications :{" "}
                                            </strong>
                                            {MachineDetails?.dataList1[0]
                                              ?.outputsamplefileurl && (
                                                <Link
                                                  target="_blank"
                                                  className="theme-color-text"
                                                  to={
                                                    MachineDetails?.dataList1[0]
                                                      ?.outputsamplefileurl
                                                  }
                                                >
                                                  <span className="input-download-icon">
                                                    <img
                                                      src={downloadIcon}
                                                      alt="downloadIcon"
                                                    />
                                                    Download
                                                  </span>
                                                </Link>
                                              )}
                                          </div>
                                          {MachineDetails?.dataList2[0]
                                            ?.outputdescription ? (
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  MachineDetails?.dataList2[0]
                                                    ?.outputdescription,
                                              }}
                                            />
                                          ) : (
                                            " - "
                                          )}
                                        </li>
                                      </ul>
                                    )}
                                  </div>
                                </div>
                                <div className="key-benifits-main my-3">
                                  <div className="machine-edit">
                                    <h4>Infrastructure Requirement</h4>
                                    {getEditStatus?.infrastructurereq ===
                                      false ? (
                                      <img
                                        src={editPencil}
                                        alt="edit-Infrastructure Requirement"
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                  <ul className="infrastructure-requirement">
                                    <li>
                                      <strong>OS Requirement : </strong>
                                      {MachineDetails?.dataList2[0]?.osrequirmet
                                        ? MachineDetails?.dataList2[0]
                                          ?.osrequirmet
                                        : " - "}
                                    </li>
                                    {/* <li>
                              <strong>Storage : </strong>
                              {MachineDetails?.dataList2[0]?.storage
                                ? MachineDetails?.dataList2[0]?.storage
                                : " - "}
                            </li> */}
                                    <li>
                                      <strong>CPU : </strong>
                                      {MachineDetails?.dataList2[0]?.cpu
                                        ? MachineDetails?.dataList2[0]?.cpu
                                        : " - "}
                                    </li>
                                    <li>
                                      <strong>Cloud : </strong>
                                      {MachineDetails?.dataList2[0]?.cloud
                                        ? MachineDetails?.dataList2[0]?.cloud
                                        : " - "}
                                    </li>
                                    <li>
                                      <strong>RAM : </strong>
                                      {MachineDetails?.dataList2[0]?.ram
                                        ? MachineDetails?.dataList2[0]?.ram
                                        : " - "}
                                    </li>
                                  </ul>
                                </div>
                                <div className="key-benifits-main">
                                  <h4>Usage Stats</h4>
                                  <ul className="infrastructure-requirement">
                                    <li>
                                      <strong>Total OnBoarded : </strong>
                                      {MachineDetails?.dataList2[0]
                                        ?.totlworkflows
                                        ? commonservices.NumberCalculateValue(
                                          MachineDetails?.dataList2[0]
                                            ?.totlworkflows
                                        )
                                        : " 0 "}
                                    </li>
                                    <li>
                                      <strong>Active OnBoarding : </strong>
                                      {MachineDetails?.dataList2[0]
                                        ?.activeworkflows
                                        ? commonservices.NumberCalculateValue(
                                          MachineDetails?.dataList2[0]
                                            ?.activeworkflows
                                        )
                                        : " 0 "}
                                    </li>
                                  </ul>
                                </div>
                                {/* <ViewSimillar
                                  similarMachineList={similarMachineList}
                                  param={param}
                                /> */}
                              </Tab>
                              {(!getEditStatus?.parametersadded ||
                                MachineDetails?.dataList3?.length > 0) && (
                                  <Tab
                                    eventKey="Parameters"
                                    className="parameters-tabbing mystickcontenttab"
                                    // title="Parameters"
                                    title={
                                      <span
                                        style={{
                                          color: hasErrorInOverview("Parameters")
                                            ? "red"
                                            : "inherit",
                                        }}
                                      >
                                        Parameters
                                      </span>
                                    }
                                  >
                                    <div
                                      // className="red-bordered-box"
                                      className={
                                        VersionState?.status === "Rejected" &&
                                        getEditStatus?.parametersadded ===
                                        false &&
                                        "red-bordered-box"
                                      }
                                    >
                                      {VersionState?.status === "Rejected" &&
                                        getEditStatus?.parametersadded === false &&
                                        !showFAQBtn ? (
                                        <button
                                          className="red-btn sm-red-btn w-auto mb12 ms-auto"
                                          onClick={(e) => {
                                            setRejectDetailModalShow(true);
                                            setRejectDetailModaldata(
                                              getEditStatus?.parametersaddedcomment ||
                                              ""
                                            );
                                          }}
                                        >
                                          <span>
                                            <img
                                              src={openeye}
                                              alt="comment"
                                              className="cursor-pointer"
                                            />
                                          </span>
                                          <span>Comment</span>
                                        </button>
                                      ) : (
                                        ""
                                      )}
                                      <div className="table-wrapper-main">
                                        <Table responsive>
                                          <thead>
                                            <tr>
                                              <th className="width450">
                                                Parameter Name
                                              </th>
                                              <th className="">Type</th>
                                              <th className="text-end width100">
                                                Description
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {MachineDetails?.dataList3?.length >
                                              0 ? (
                                              MachineDetails?.dataList3?.map(
                                                (item) => {
                                                  return (
                                                    <tr
                                                      key={`parameter${item?.machineconfigparaid}`}
                                                    >
                                                      <td className="text-capitalize width450">
                                                        {item?.parakey?.replaceAll(
                                                          "_",
                                                          " "
                                                        )}
                                                      </td>
                                                      <td className="text-capitalize">
                                                        {item?.paratype}
                                                      </td>
                                                      <td className="text-end">
                                                        <img
                                                          id={`parameter${item?.machineconfigparaid}`}
                                                          src={sminfo}
                                                          alt="sminfo"
                                                          className="sminfo-in-table cursor-pointer"
                                                          onClick={(e) => {
                                                            e.preventDefault();
                                                            targetInputDetail.current =
                                                              document.querySelector(
                                                                `#parameter${item?.machineconfigparaid}`
                                                              );
                                                            paraDetailRef.current =
                                                              item;
                                                            handleOverlay(e);
                                                            setShowInputDetailPopu(
                                                              !showInputDetailPopup
                                                            );
                                                            handleShowInputDetailPopup();
                                                          }}
                                                        />
                                                        {VersionState?.status ===
                                                          "Rejected" &&
                                                          getEditStatus?.parametersadded ===
                                                          false && (
                                                            <img
                                                              style={{
                                                                width: "16px",
                                                                height: "16px",
                                                              }}
                                                              src={editAction}
                                                              title="edit"
                                                              alt="editAction"
                                                              className="ms-2 cursor-pointer"
                                                              onClick={(e) => {
                                                                // setParameterModalIndex(index);
                                                                e.preventDefault();
                                                                setParameterEditAddMachineModalShow(
                                                                  true
                                                                );
                                                                setParameterEditAddMachineModaltype(
                                                                  "Edit"
                                                                );
                                                                setParameterEditAddSelectedData(
                                                                  item
                                                                );

                                                                setUpdateReviewCommentData(
                                                                  {
                                                                    ...UpdateReviewCommentData,
                                                                    booleanfield:
                                                                      "parametersadded",
                                                                    commentfield:
                                                                      "parametersaddedcomment",
                                                                    commentfieldvalue:
                                                                      getEditStatus?.parametersaddedcomment,
                                                                  }
                                                                );
                                                              }}
                                                            />
                                                          )}
                                                      </td>
                                                    </tr>
                                                  );
                                                }
                                              )
                                            ) : (
                                              <tr className="text-center">
                                                <td colSpan={3}>
                                                  <Nodata />
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </Table>
                                      </div>
                                      {VersionState?.status === "Rejected" &&
                                        getEditStatus?.parametersadded ===
                                        false && (
                                          <>
                                            {paramArray?.length <
                                              MachineDetails?.dataList3
                                                ?.length && (
                                                <button
                                                  disabled={Loading}
                                                  className="blue-btn mt-2 d-flex w-auto ms-auto btn-sm"
                                                  onClick={(e) =>
                                                    updateReviewStatusForParameters(
                                                      e,
                                                      "PARAMS"
                                                    )
                                                  }
                                                >
                                                  {Loading ? (
                                                    <SubmitLoading />
                                                  ) : (
                                                    "Submit"
                                                  )}
                                                </button>
                                              )}
                                          </>
                                        )}
                                    </div>
                                    {/* <ViewSimillar
                                    similarMachineList={similarMachineList}
                                    param={param}
                                  /> */}
                                  </Tab>
                                )}
                              {MachineVersionList?.length > 0 && (
                                <Tab
                                  className="mystickcontenttab"
                                  eventKey="Version History"
                                  id="version-change"
                                  title={
                                    <span
                                      style={{
                                        color: hasErrorInOverview("Versions")
                                          ? "red"
                                          : "inherit",
                                      }}
                                    >
                                      Versions
                                    </span>
                                  }
                                // ref={divRef}
                                >
                                  <div className="versions-main">
                                    <Accordion className="versions-accordion">
                                      {MachineVersionList?.length > 0 ? (
                                        MachineVersionList?.map(
                                          (item, index) => (
                                            <React.Fragment key={index}>
                                              <Accordion.Item
                                                eventKey={`${index}`}
                                              >
                                                <Accordion.Header
                                                  onClick={() => {
                                                    getMachineVersionDetail(
                                                      item?.machineid,
                                                      item?.versionnumber
                                                    );
                                                  }}
                                                >
                                                  <div className="d-flex gap-3 align-items-center">
                                                    <span
                                                      onClick={(e) => {
                                                        e.preventDefault();
                                                        setVersionState({
                                                          machinename:
                                                            item?.machinename,
                                                          number:
                                                            item?.versionnumber,
                                                          status: item?.status,
                                                          date: item?.isdiscontinued
                                                            ? item?.discontinueddate
                                                            : item?.isdeprecated
                                                              ? item?.deprecateddate
                                                              : "",
                                                          action:
                                                            item?.isdiscontinued
                                                              ? "discontinued"
                                                              : item?.isdeprecated
                                                                ? "deprecating"
                                                                : "",
                                                          reason:
                                                            item?.isdiscontinued
                                                              ? item?.discontinuereason
                                                              : item?.isdeprecated
                                                                ? item?.deprecatedreason
                                                                : "",
                                                          machineid:
                                                            item?.machineid,
                                                          price: item?.price,
                                                        });
                                                        getMachineDetails(
                                                          item?.machineid
                                                        );
                                                        getFAQList(
                                                          item?.machineid
                                                        );
                                                      }}
                                                    >
                                                      {item?.versionnumber}
                                                    </span>
                                                    <span>
                                                      {item?.lastupdatedon
                                                        ? commonservices.getDateInFormatCustom(
                                                          item?.lastupdatedon,
                                                          null,
                                                          "MMMM DD,YYYY"
                                                        )
                                                        : "-"}
                                                    </span>
                                                  </div>
                                                  {param?.pagename ===
                                                    "my machine" && (
                                                      <>
                                                        {!item?.isdiscontinued && (
                                                          <>
                                                            <div
                                                              className={
                                                                item?.status ===
                                                                  "Rejected" ||
                                                                  item?.status ===
                                                                  "Publish"
                                                                  ? "all-actions"
                                                                  : ""
                                                              }
                                                            // className="all-actions"
                                                            >
                                                              {!item?.isdeprecated &&
                                                                (item?.status ===
                                                                  "Rejected" ||
                                                                  item?.status ===
                                                                  "Publish") && (
                                                                  // ) ||
                                                                  // (item?.status ===
                                                                  //   "Publish"
                                                                  <>
                                                                    <img
                                                                      title="Update"
                                                                      src={
                                                                        updateIcon
                                                                      }
                                                                      alt="updateAction"
                                                                      onClick={(
                                                                        e
                                                                      ) => {
                                                                        e.preventDefault();
                                                                        navigate(
                                                                          `/marketplace/marketplace-detail/${commonservices.bodyEncryption(
                                                                            String(
                                                                              item?.machineid
                                                                            )
                                                                          )}/update-version/${item?.versionnumber
                                                                          }`
                                                                        );
                                                                      }}
                                                                    />
                                                                    {item?.status ===
                                                                      "Publish" && (
                                                                        <img
                                                                          title="Deprecate"
                                                                          src={
                                                                            deprecateIcon
                                                                          }
                                                                          alt="depricateAction"
                                                                          onClick={(
                                                                            e
                                                                          ) => {
                                                                            e.stopPropagation();
                                                                            machineDetailRef.current =
                                                                            {
                                                                              ...machineDetailRef.current,
                                                                              version:
                                                                                item?.versionnumber,
                                                                            };
                                                                            setMachineModaldata(
                                                                              item
                                                                            );
                                                                            setMachineModalShow(
                                                                              true
                                                                            );
                                                                            setMachineModalType(
                                                                              "Deprecate"
                                                                            );
                                                                          }}
                                                                        />
                                                                      )}
                                                                  </>
                                                                )}
                                                              {item?.status ===
                                                                "Publish" && (
                                                                  <img
                                                                    title="Discontinue"
                                                                    src={
                                                                      discontinueIcon
                                                                    }
                                                                    alt="discontinueAction"
                                                                    onClick={(
                                                                      e
                                                                    ) => {
                                                                      e.stopPropagation();
                                                                      machineDetailRef.current =
                                                                      {
                                                                        ...machineDetailRef.current,
                                                                        version:
                                                                          item?.versionnumber,
                                                                      };
                                                                      setMachineModaldata(
                                                                        item
                                                                      );
                                                                      setMachineModalShow(
                                                                        true
                                                                      );
                                                                      setMachineModalType(
                                                                        "Discontinue"
                                                                      );
                                                                    }}
                                                                  />
                                                                )}
                                                            </div>
                                                          </>
                                                        )}
                                                      </>
                                                    )}
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                  {UpdateResolveDetail?.map(
                                                    (itemData, indexNo) => {
                                                      return (
                                                        <div
                                                          className="version-data"
                                                          key={indexNo}
                                                        >
                                                          <p className="versionDate">
                                                            {commonservices.getDateInFormatCustom(
                                                              itemData !== "" &&
                                                                itemData?.versionnumber ===
                                                                item?.versionnumber
                                                                ? itemData?.entrydate
                                                                : item?.isdiscontinued
                                                                  ? item?.discontinueddate
                                                                  : item?.isdeprecated
                                                                    ? item?.deprecateddate
                                                                    : item?.status ===
                                                                      "Rejected"
                                                                      ? item?.reviewon
                                                                      : item?.status ===
                                                                        "Pending"
                                                                        ? item?.lastupdatedon
                                                                        : null,
                                                              null,
                                                              "MMMM DD, YYYY"
                                                            )}
                                                          </p>

                                                          <div className="machine-accordion-data">
                                                            {item?.status ===
                                                              "Rejected"
                                                              ? item?.reviewreason
                                                              : itemData !==
                                                              "" &&
                                                              itemData?.versionnumber ===
                                                              item?.versionnumber && (
                                                                <>
                                                                  {itemData?.bugresolved ? (
                                                                    <div
                                                                      dangerouslySetInnerHTML={{
                                                                        __html:
                                                                          itemData?.bugresolved,
                                                                      }}
                                                                    />
                                                                  ) : (
                                                                    "--"
                                                                  )}
                                                                </>
                                                              )}
                                                          </div>
                                                        </div>
                                                      );
                                                    }
                                                  )}
                                                </Accordion.Body>
                                              </Accordion.Item>
                                            </React.Fragment>
                                          )
                                          // );
                                          // }
                                        )
                                      ) : (
                                        <Nodata />
                                      )}
                                    </Accordion>
                                  </div>
                                  {/* <ViewSimillar
                                    similarMachineList={similarMachineList}
                                    param={param}
                                  /> */}
                                </Tab>
                              )}
                              <Tab
                                className="mystickcontenttab"
                                eventKey="Review & Ratings"
                                id="version-change"
                                title={
                                  <span
                                    style={{
                                      color: hasErrorInOverview(
                                        "Review & Ratings"
                                      )
                                        ? "red"
                                        : "inherit",
                                    }}
                                  >
                                    Review & Ratings
                                  </span>
                                }
                              // ref={divRef}
                              >
                                <div className="all-reviews-main marketplace-review-main">
                                  {/* <h6>Reviews</h6> */}
                                  <div className="all-reviews-top">
                                    <div className="all-reviews-top-single">
                                      <h4>Total Reviews</h4>
                                      <h3>
                                        {MachineDetails?.dataList2[0]
                                          ?.totalreview > 0
                                          ? commonservices.NumberCalculateValue(
                                            MachineDetails?.dataList2[0]
                                              ?.totalreview
                                          )
                                          : 0}
                                      </h3>
                                    </div>
                                    <div className="all-reviews-top-single">
                                      <h4>Total Ratings</h4>
                                      <h3>
                                        {MachineDetails?.dataList2[0]
                                          ?.totalrating > 0
                                          ? commonservices.NumberCalculateValue(
                                            MachineDetails?.dataList2[0]
                                              ?.totalrating
                                          )
                                          : 0}
                                      </h3>
                                    </div>
                                    <div className="all-reviews-top-single">
                                      <h4>Average Rating</h4>
                                      <h3 className="d-flex gap-2 align-items-center">
                                        {MachineDetails?.dataList2[0]?.averagerating?.toFixed(
                                          1
                                        )}
                                        <span>
                                          {"  "}
                                          <StarRating
                                            filledStars={
                                              MachineDetails?.dataList2[0]
                                                ?.averagerating
                                            }
                                          />
                                        </span>
                                      </h3>
                                      {/* <h6>
                                {commonservices.NumberCalculateValue(
                                  MachineDetails?.dataList2[0]?.totalrating
                                )}{" "}
                                ratings
                              </h6> */}
                                    </div>
                                    <div className="all-review-star-vise w-100">
                                      <div className="five-star-rating">
                                        <div className="d-flex align-items-center gap-1">
                                          <img src={star} alt="star" />
                                          <p>5</p>
                                        </div>
                                        <div
                                          className="review-line"
                                          // style={{ width: "170px", background: "#3ABAA0" }}
                                          style={{
                                            // width: reviewWidths.total5start,
                                            width: `${2 +
                                              parseInt(reviewWidths.total5start)
                                              }%`,
                                            background: "#3ABAA0",
                                          }}
                                        ></div>
                                        <span>
                                          {commonservices.NumberCalculateValue(
                                            MachineDetails?.dataList2[0]?.[
                                              "5star"
                                            ] !== null
                                              ? MachineDetails?.dataList2[0]?.[
                                              "5star"
                                              ]
                                              : 0
                                          )}
                                        </span>
                                      </div>
                                      <div className="five-star-rating">
                                        <div className="d-flex align-items-center gap-1">
                                          <img src={star} alt="star" />
                                          <p>4</p>
                                        </div>
                                        <div
                                          className="review-line"
                                          // style={{ width: "200px", background: "#DC7EFF" }}
                                          style={{
                                            // width: reviewWidths.total4start,
                                            width: `${2 +
                                              parseInt(reviewWidths.total4start)
                                              }%`,
                                            background: "#DC7EFF",
                                          }}
                                        ></div>
                                        <span>
                                          {commonservices.NumberCalculateValue(
                                            MachineDetails?.dataList2[0]?.[
                                              "4star"
                                            ] !== null
                                              ? MachineDetails?.dataList2[0]?.[
                                              "4star"
                                              ]
                                              : 0
                                          )}
                                        </span>
                                      </div>
                                      <div className="five-star-rating">
                                        <div className="d-flex align-items-center gap-1">
                                          <img src={star} alt="star" />
                                          <p>3</p>
                                        </div>
                                        <div
                                          className="review-line"
                                          // style={{ width: "100px", background: "#F5C044" }}
                                          style={{
                                            // width: reviewWidths.total3start,
                                            width: `${2 +
                                              parseInt(reviewWidths.total3start)
                                              }%`,
                                            background: "#F5C044",
                                          }}
                                        ></div>
                                        <span>
                                          {commonservices.NumberCalculateValue(
                                            MachineDetails?.dataList2[0]?.[
                                              "3star"
                                            ] !== null
                                              ? MachineDetails?.dataList2[0]?.[
                                              "3star"
                                              ]
                                              : 0
                                          )}
                                        </span>
                                      </div>
                                      <div className="five-star-rating">
                                        <div className="d-flex align-items-center gap-1">
                                          <img src={star} alt="star" />
                                          <p>2</p>
                                        </div>
                                        <div
                                          className="review-line"
                                          // style={{ width: "40px", background: "#35C4F3" }}
                                          style={{
                                            // width: reviewWidths.total2start,
                                            width: `${2 +
                                              parseInt(reviewWidths.total2start)
                                              }%`,
                                            background: "#35C4F3",
                                          }}
                                        ></div>
                                        <span>
                                          {commonservices.NumberCalculateValue(
                                            MachineDetails?.dataList2[0]?.[
                                              "2star"
                                            ] !== null
                                              ? MachineDetails?.dataList2[0]?.[
                                              "2star"
                                              ]
                                              : 0
                                          )}
                                        </span>
                                      </div>
                                      <div className="five-star-rating">
                                        <div className="d-flex align-items-center gap-1">
                                          <img src={star} alt="star" />
                                          <p>1</p>
                                        </div>
                                        <div
                                          className="review-line"
                                          // style={{ width: "10px", background: "#F96B0D" }}
                                          style={{
                                            width: `${2 +
                                              parseInt(reviewWidths.total1start)
                                              }%`,
                                            // width: reviewWidths.total1start,
                                            background: "#F96B0D",
                                          }}
                                        ></div>
                                        <span>
                                          {commonservices.NumberCalculateValue(
                                            MachineDetails?.dataList2[0]?.[
                                              "1star"
                                            ] !== null
                                              ? MachineDetails?.dataList2[0]?.[
                                              "1star"
                                              ]
                                              : 0
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                    {param?.pagename !== "my machine" &&
                                      parseInt(Userdata?.subscriberid) !==
                                      parseInt(
                                        MachineDetails?.dataList1?.[0]
                                          ?.subscriberid
                                      ) && (
                                        <div className="write-review">
                                          <button
                                            className="blue-btn w-auto"
                                            onClick={() => {
                                              setShowReviewModal(true);
                                            }}
                                          >
                                            Write Review
                                          </button>
                                        </div>
                                      )}
                                  </div>
                                  <div className="all-written-review">
                                    {MachineDetails?.dataList4?.length > 0 &&
                                      MachineDetails?.dataList4?.map(
                                        (item_md4, index_md4) => (
                                          <div
                                            key={index_md4}
                                            className="single-written-review"
                                          >
                                            <div className="single-written-review-left">
                                              {/* <img
                                  src={reviewprofile}
                                  alt="reviewprofile"
                                  className="reviewprofile"
                                /> */}
                                              <img
                                                src={
                                                  item_md4?.profilepic
                                                    ? item_md4?.profilepic
                                                    : profilepic
                                                }
                                                alt="profilepic"
                                                onError={({
                                                  currentTarget,
                                                }) => {
                                                  currentTarget.onerror = null;
                                                  currentTarget.src =
                                                    profilepic;
                                                }}
                                                className="reviewprofile"
                                              />
                                              <div>
                                                <h5>
                                                  {commonservices.truncateText(
                                                    item_md4?.displayname,
                                                    CountCharacter.ReviewTitle
                                                  )}
                                                </h5>
                                                {/* <h5>{item_md4?.displayname}</h5> */}
                                                <p>
                                                  {item_md4?.entrydate
                                                    ? commonservices.getDateInFormatCustom(
                                                      item_md4?.entrydate,
                                                      null,
                                                      "MM/DD/yyyy"
                                                    )
                                                    : " - "}
                                                </p>
                                                {/* <img src={fourstar} alt="fourstar" /> */}
                                                <StarRating
                                                  filledStars={
                                                    item_md4?.userrating
                                                  }
                                                />
                                              </div>
                                            </div>
                                            <div className="single-written-review-right">
                                              <p>
                                                {/* {CustomtruncateText(
                                    item_md4?.userreview,
                                    245
                                  )} */}
                                                {item_md4?.userreview?.length >
                                                  CountCharacter?.MarketPlaceReviewDetail ? (
                                                  <>
                                                    {MoreLessState.flag &&
                                                      MoreLessState.index ===
                                                      index_md4
                                                      ? item_md4?.userreview
                                                      : item_md4?.userreview.substring(
                                                        0,
                                                        CountCharacter?.MarketPlaceReviewDetail
                                                      )}
                                                    <span
                                                      className="ms-1"
                                                      onClick={(e) => {
                                                        // setMoreLessState(
                                                        //   !MoreLessState
                                                        // );
                                                        if (
                                                          MoreLessState.flag &&
                                                          MoreLessState.index ===
                                                          index_md4
                                                        ) {
                                                          setMoreLessState({
                                                            flag: false,
                                                            index: index_md4,
                                                          });
                                                        } else {
                                                          setMoreLessState({
                                                            flag: true,
                                                            index: index_md4,
                                                          });
                                                        }
                                                      }}
                                                    >
                                                      {MoreLessState.flag &&
                                                        MoreLessState.index ===
                                                        index_md4
                                                        ? "less"
                                                        : "more"}
                                                      {/* {MoreLessState
                                                    ? "less"
                                                    : "more"} */}
                                                      ...
                                                    </span>
                                                  </>
                                                ) : (
                                                  item_md4?.userreview
                                                )}
                                              </p>
                                            </div>
                                          </div>
                                        )
                                      )}
                                  </div>
                                </div>
                                {/* <ViewSimillar
                                  similarMachineList={similarMachineList}
                                  param={param}
                                /> */}
                              </Tab>
                              {(!getEditStatus?.faqadded ||
                                FAQList?.length > 0) && (
                                  <Tab
                                    className="mystickcontenttab"
                                    eventKey="FAQs"
                                    title={
                                      <span
                                        style={{
                                          color: hasErrorInOverview("FAQs")
                                            ? "red"
                                            : "inherit",
                                        }}
                                      >
                                        FAQs
                                      </span>
                                    }
                                  >
                                    <div
                                      className={
                                        VersionState?.status === "Rejected" &&
                                        getEditStatus?.faqadded === false &&
                                        "red-bordered-box"
                                      }
                                    >
                                      <div className="faqs-main">
                                        {/* <h3>FAQs</h3> */}
                                        {VersionState?.status === "Rejected" &&
                                          getEditStatus?.faqadded === false &&
                                          !showFAQBtn ? (
                                          <button
                                            className="red-btn sm-red-btn w-auto mb12 ms-auto"
                                            onClick={(e) => {
                                              setRejectDetailModalShow(true);
                                              setRejectDetailModaldata(
                                                getEditStatus?.faqaddedcomment ||
                                                ""
                                              );
                                            }}
                                          >
                                            <span>
                                              <img
                                                src={openeye ? openeye : openeye}
                                                alt="comment"
                                                className="cursor-pointer"
                                              />
                                            </span>
                                            <span>Comment</span>
                                          </button>
                                        ) : (
                                          ""
                                        )}
                                        <div className="all-categories-of-market-place">
                                          {FAQLoader ? (
                                            <Loader
                                              type={LoaderType.Line}
                                              count={5}
                                            />
                                          ) : FAQList?.length > 0 ? (
                                            FAQList?.map((item_f, index_f) => (
                                              <React.Fragment key={index_f}>
                                                <Accordion
                                                  defaultActiveKey={["0"]}
                                                  alwaysOpen
                                                  className="accordion-for-faqs-only"
                                                >
                                                  <Accordion.Item
                                                    eventKey={index_f?.toString()}
                                                  >
                                                    <Accordion.Header>
                                                      <span>
                                                        <b>{item_f?.question}</b>
                                                      </span>
                                                    </Accordion.Header>
                                                    {VersionState?.status ===
                                                      "Rejected" &&
                                                      getEditStatus?.faqadded ===
                                                      false &&
                                                      !showFAQBtn ? (
                                                      <>
                                                        <button
                                                          className="black-btn sm-black-btn editibutton-rejectmachine w-auto"
                                                          onClick={(e) => {
                                                            e.preventDefault();
                                                            setFaqtype("Edit");
                                                            setFAQEditAddSelectedData(
                                                              item_f
                                                            );
                                                            setShowFaqModal(true);
                                                            setUpdateReviewCommentData(
                                                              {
                                                                ...UpdateReviewCommentData,
                                                                booleanfield:
                                                                  "faqadded",
                                                                commentfield:
                                                                  "faqaddedcomment",
                                                                commentfieldvalue:
                                                                  getEditStatus?.faqaddedcomment,
                                                              }
                                                            );
                                                          }}
                                                        >
                                                          <span>
                                                            <img
                                                              src={editPencil}
                                                              alt="edit-Classification"
                                                            />
                                                          </span>
                                                          {/* <span>Edit</span> */}
                                                        </button>
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}
                                                    <Accordion.Body>
                                                      <p
                                                        dangerouslySetInnerHTML={{
                                                          __html: item_f?.answer,
                                                        }}
                                                      />
                                                    </Accordion.Body>
                                                  </Accordion.Item>
                                                </Accordion>
                                              </React.Fragment>
                                            ))
                                          ) : (
                                            <Nodata />
                                          )}
                                        </div>
                                        {VersionState?.status === "Rejected" &&
                                          getEditStatus?.faqadded === false && (
                                            <>
                                              {FAQListData?.length <
                                                FAQList?.length && (
                                                  <button
                                                    disabled={Loading}
                                                    className="blue-btn mt-2 d-flex w-auto ms-auto btn-sm"
                                                    onClick={(e) =>
                                                      updateReviewStatusForParameters(
                                                        e,
                                                        "FAQ"
                                                      )
                                                    }
                                                  >
                                                    {Loading ? (
                                                      <SubmitLoading />
                                                    ) : (
                                                      "Submit"
                                                    )}
                                                  </button>
                                                )}
                                            </>
                                          )}
                                      </div>
                                    </div>
                                    {/* <ViewSimillar
                                    similarMachineList={similarMachineList}
                                    param={param}
                                  /> */}
                                  </Tab>
                                )}
                              <Tab
                                className="mystickcontenttab"
                                eventKey="Sample Data"
                                title={
                                  <span
                                    style={{
                                      color: hasErrorInOverview("Sample Data")
                                        ? "red"
                                        : "inherit",
                                    }}
                                  >
                                    Sample Data
                                  </span>
                                }
                              >
                                <div
                                  className={
                                    VersionState?.status === "Rejected" &&
                                    getEditStatus?.specification === false &&
                                    "red-bordered-box"
                                  }
                                >
                                  {VersionState?.status === "Rejected" &&
                                    getEditStatus?.specification === false &&
                                    !showFAQBtn ? (
                                    <>
                                      <div className="d-flex align-items-center gap-2 justify-content-end mb12">
                                        <button
                                          className="red-btn sm-red-btn w-auto"
                                          onClick={(e) => {
                                            setRejectDetailModalShow(true);
                                            setRejectDetailModaldata(
                                              getEditStatus?.specificationcomment ||
                                              ""
                                            );
                                          }}
                                        >
                                          <span>
                                            <img
                                              src={openeye}
                                              alt="comment"
                                              className="cursor-pointer"
                                            />
                                          </span>
                                          <span>Comment</span>
                                        </button>
                                        <button
                                          className="black-btn sm-black-btn  w-auto"
                                          onClick={() => {
                                            handleSampleDataClick();
                                            setUpdateReviewCommentData({
                                              ...UpdateReviewCommentData,
                                              booleanfield: "specification",
                                              commentfield:
                                                "specificationcomment",
                                              commentfieldvalue:
                                                getEditStatus?.specificationcomment,
                                            });
                                          }}
                                        >
                                          <span>
                                            <img
                                              src={editPencil}
                                              alt="editmachineOverview"
                                            />
                                          </span>
                                          <span>Edit</span>
                                        </button>
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}

                                  <div className="key-benifits-main">
                                    <div className="machine-edit">
                                      <h4>Specifications</h4>
                                    </div>
                                    {VersionState?.status === "Rejected" &&
                                      getEditStatus?.specification === false &&
                                      showSampleDataionBtn ? (
                                      <Specifications
                                        getlist={MachineDetails}
                                        machineId={
                                          MachineDetails?.dataList1[0]
                                            ?.machineid
                                        }
                                        bindlist={getMachineDetails}
                                        versionlist={VersionState}
                                        updatereviewcommentdata={
                                          UpdateReviewCommentData
                                        }
                                        geteditstatus={getEditStatus}
                                        handleclose={handleSampleDataClick}
                                        setmachinedetails={setMachineDetails}
                                      />
                                    ) : (
                                      <ul>
                                        <li>
                                          <div className="d-flex align-items-center gap-2 mb-1">
                                            <strong>
                                              Input Specifications :{" "}
                                            </strong>
                                            {MachineDetails?.dataList1[0]
                                              ?.inputsamplefileurl && (
                                                <Link
                                                  target="_blank"
                                                  className="theme-color-text"
                                                  to={
                                                    MachineDetails?.dataList1[0]
                                                      ?.inputsamplefileurl
                                                  }
                                                >
                                                  <span className="input-download-icon">
                                                    <img
                                                      src={downloadIcon}
                                                      alt="downloadIcon"
                                                    />
                                                    Download
                                                  </span>
                                                </Link>
                                              )}
                                          </div>
                                          {MachineDetails?.dataList2[0]
                                            ?.inputdescription ? (
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  MachineDetails?.dataList2[0]
                                                    ?.inputdescription,
                                              }}
                                            />
                                          ) : (
                                            " - "
                                          )}
                                        </li>
                                        <li>
                                          <div className="d-flex align-items-center gap-2 mb-1">
                                            <strong>
                                              Output Specifications :{" "}
                                            </strong>
                                            {MachineDetails?.dataList1[0]
                                              ?.outputsamplefileurl && (
                                                <Link
                                                  target="_blank"
                                                  className="theme-color-text"
                                                  to={
                                                    MachineDetails?.dataList1[0]
                                                      ?.outputsamplefileurl
                                                  }
                                                >
                                                  <span className="input-download-icon">
                                                    <img
                                                      src={downloadIcon}
                                                      alt="downloadIcon"
                                                    />
                                                    Download
                                                  </span>
                                                </Link>
                                              )}
                                          </div>
                                          {MachineDetails?.dataList2[0]
                                            ?.outputdescription ? (
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  MachineDetails?.dataList2[0]
                                                    ?.outputdescription,
                                              }}
                                            />
                                          ) : (
                                            " - "
                                          )}
                                        </li>
                                      </ul>
                                    )}
                                  </div>
                                </div>
                                {/* <ViewSimillar
                                  similarMachineList={similarMachineList}
                                  param={param}
                                /> */}
                              </Tab>
                              {param?.pagename === "my machine" && (
                                <Tab
                                  className="mystickcontenttab"
                                  eventKey="Source Code"
                                  title={
                                    <span
                                      style={{
                                        color: hasErrorInOverview("Source Code")
                                          ? "red"
                                          : "inherit",
                                      }}
                                    >
                                      Source Code
                                    </span>
                                  }
                                >
                                  <div
                                    className={
                                      VersionState?.status === "Rejected" &&
                                      hasErrorInOverview("Source Code") &&
                                      "red-bordered-box"
                                    }
                                  >
                                    <div className="machine-edit">
                                      <h4></h4>
                                      {VersionState?.status === "Rejected" &&
                                        hasErrorInOverview("Source Code") ? (
                                        <>
                                          <div className="d-flex align-items-center gap-2 justify-content-end mb12">
                                            <button
                                              className="red-btn sm-red-btn w-auto"
                                              onClick={(e) => {
                                                let a = {};
                                                if (
                                                  getEditStatus?.codestructurecomment
                                                ) {
                                                  a["Code Structure"] =
                                                    getEditStatus?.codestructurecomment;
                                                }
                                                if (
                                                  getEditStatus?.codequalitycomment
                                                ) {
                                                  a["Code Quality"] =
                                                    getEditStatus?.codequalitycomment;
                                                }
                                                if (
                                                  getEditStatus?.functionalitycomment
                                                ) {
                                                  a["Functionality"] =
                                                    getEditStatus?.functionalitycomment;
                                                }
                                                if (
                                                  getEditStatus?.securitycomment
                                                ) {
                                                  a["Security"] =
                                                    getEditStatus?.securitycomment;
                                                }
                                                if (
                                                  getEditStatus?.performancecomment
                                                ) {
                                                  a[
                                                    "Performance and Efficiency"
                                                  ] =
                                                    getEditStatus?.performancecomment;
                                                }
                                                if (
                                                  getEditStatus?.testingandcoveragecomment
                                                ) {
                                                  a["Testing and Coverage"] =
                                                    getEditStatus?.testingandcoveragecomment;
                                                }
                                                if (
                                                  getEditStatus?.compliancestandardcomment
                                                ) {
                                                  a[
                                                    "Compliance and Standards"
                                                  ] =
                                                    getEditStatus?.compliancestandardcomment;
                                                }
                                                if (
                                                  getEditStatus?.mocktestcomment
                                                ) {
                                                  a["Mock Test"] =
                                                    getEditStatus?.mocktestcomment;
                                                }
                                                setRejectDetailModalShow(true);
                                                setRejectDetailModaldata(a);
                                              }}
                                            >
                                              <span>
                                                <img
                                                  src={openeye}
                                                  alt="comment"
                                                  className="cursor-pointer"
                                                />
                                              </span>
                                              <span>Comment</span>
                                            </button>
                                            <button
                                              className="black-btn sm-black-btn  w-auto"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                navigate(
                                                  `/marketplace/marketplace-detail/${commonservices.bodyEncryption(
                                                    String(
                                                      VersionState?.machineid
                                                    )
                                                  )}/update-version/${VersionState?.number
                                                  }`
                                                );
                                              }}
                                            >
                                              <span>
                                                <img
                                                  src={editPencil}
                                                  alt="editmachineOverview"
                                                />
                                              </span>
                                              <span>Edit</span>
                                            </button>
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    {fileStructureLoading ? (
                                      <Loader
                                        type={LoaderType.SourceCode}
                                        count={13}
                                      />
                                    ) : (
                                      <>
                                        {fileStructure?.length > 0 ? (
                                          <div className="source-code-main">
                                            <Col xl={12}>
                                              <Row>
                                                <Col xl={3}>
                                                  <div className="source-code-left">
                                                    <div className="code-folder-structure-wrapper">
                                                      {fileStructureLoading ? (
                                                        <div className="m-2">
                                                          <Loader
                                                            type={
                                                              LoaderType.Files
                                                            }
                                                            count={10}
                                                          />
                                                        </div>
                                                      ) : (
                                                        fileStructure && (
                                                          <FileStructure
                                                            data={fileStructure}
                                                            getGitRepoFileContent={
                                                              getGitRepoFileContent
                                                            }
                                                            selectedFile={
                                                              selectedFile
                                                            }
                                                            handleFileSelection={
                                                              handleFileSelection
                                                            }
                                                          />
                                                        )
                                                      )}
                                                    </div>
                                                  </div>
                                                </Col>
                                                <Col xl={9}>
                                                  <div className="source-code-right w-100">
                                                    <div className="source-code-right-header">
                                                      <div className="source-code-right-header-left">
                                                        <div className="file-size">
                                                          <p>/{selectedFile}</p>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      style={{
                                                        height: "500px",
                                                        width: "100%",
                                                      }}
                                                    >
                                                      {fileContentLoading ? (
                                                        <Loader
                                                          type={
                                                            LoaderType.FileContent
                                                          }
                                                          count={13}
                                                        />
                                                      ) : (
                                                        <>
                                                          <SyntaxHighlighter
                                                            customStyle={{
                                                              height: "100%",
                                                              width: "100%",
                                                            }}
                                                            showLineNumbers={true}
                                                            language={
                                                              typeof fileContent?.language === "string" &&
                                                                fileContent?.language.trim() !== ""
                                                                ? fileContent?.language
                                                                : "py"
                                                            }
                                                            style={a11yDark}
                                                          >
                                                            {typeof fileContent?.content === "string" &&
                                                              fileContent?.content.trim() !== ""
                                                              ? fileContent?.content
                                                              : "{}"}
                                                          </SyntaxHighlighter>
                                                          {/* <SyntaxHighlighter
                                                          customStyle={{
                                                            height: "100%",
                                                            width: "100%",
                                                          }}
                                                          showLineNumbers={true}
                                                          language={
                                                            fileContent?.language
                                                              ? fileContent?.language
                                                              : "py"
                                                          }
                                                          style={a11yDark}
                                                        >
                                                          {fileContent?.content
                                                            ? fileContent?.content
                                                            : ""}
                                                        </SyntaxHighlighter> */}
                                                        </>
                                                      )}
                                                    </div>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </Col>
                                          </div>
                                        ) : (
                                          <Nodata />
                                        )}
                                      </>
                                    )}
                                  </div>
                                  {/* <ViewSimillar
                                    similarMachineList={similarMachineList}
                                    param={param}
                                  /> */}
                                </Tab>
                              )}
                            </Tabs>
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}
                  {MachineDetailLoader ? (
                    <Loader type={LoaderType.MarketMainRight} />
                  ) : (
                    <Col xl={3} className="mb-3 all-marketplace-main-sidebar">
                      <div className="developersticky-inner">
                        <div className="parentstickey">
                          <div className="information-main mystaticstic">
                            <h2 className="mb12">Updates and Community</h2>
                            {VersionState?.action && (
                              <div className="machinewarning">
                                <div className="d-flex warninginner">
                                  <div>
                                    <img src={StopImg} />
                                  </div>
                                  <div>
                                    {" "}
                                    <h5>
                                      This machine is {VersionState?.action}{" "}
                                      from{" "}
                                      <span>
                                        {commonservices.getDateInFormatCustom(
                                          VersionState?.date,
                                          null,
                                          "MMMM DD,yyyy"
                                        )}
                                      </span>
                                    </h5>
                                    {/* <p>{VersionState?.reason}</p> */}
                                    <p
                                      dangerouslySetInnerHTML={{
                                        __html: VersionState?.reason,
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="all-informations-main">
                              <div className="single-informations-main">
                                <h5>Machine Developer</h5>
                                <Link
                                  to="/marketplace/developer"
                                  className="theme-color-text"
                                  state={{
                                    subscriberId:
                                      MachineDetails?.dataList1[0]
                                        ?.subscriberid,
                                  }}
                                >
                                  {MachineDetails?.dataList1[0]?.subscribername
                                    ? MachineDetails?.dataList1[0]
                                      ?.subscribername
                                    : " - "}
                                </Link>
                                <p className="mb-2 d-flex justify-content-between gap-2">
                                  <span className="w-50"> Last updated </span>{" "}
                                  <span className="w-50">
                                    {" "}
                                    {MachineDetails?.dataList1[0]?.lastupdatedon
                                      ? commonservices.getDateInFormatCustom(
                                        MachineDetails?.dataList1[0]
                                          ?.lastupdatedon,
                                        null,
                                        "MMMM DD,YYYY"
                                      )
                                      : " - "}
                                  </span>
                                </p>
                                <p className="d-flex justify-content-between gap-2">
                                  <span className="w-50"> Version </span>{" "}
                                  <span className="w-50">
                                    {" "}
                                    {MachineDetails?.dataList1[0]?.lastversion
                                      ? MachineDetails?.dataList1[0]
                                        ?.lastversion
                                      : " - "}{" "}
                                  </span>
                                </p>
                                {TabState !== "Version History" &&
                                  MachineVersionList?.length > 0 && (
                                    <p>
                                      <button
                                        onClick={handleVersionClick}
                                        className="btn smallbtnblack"
                                      >
                                        Version History
                                      </button>
                                    </p>
                                  )}
                              </div>
                              <div className="single-informations-main">
                                <h5>Statistics</h5>
                                <p className="mb-1 d-flex justify-content-between gap-2">
                                  <span className="w-50">Total Workflows</span>{" "}
                                  <span className="w-50">
                                    {" "}
                                    {MachineDetails?.dataList2[0]?.totlworkflows
                                      ? commonservices.NumberCalculateValue(
                                        MachineDetails?.dataList2[0]
                                          ?.totlworkflows
                                      )
                                      : " 0 "}
                                  </span>
                                </p>
                                <p className="mb-1 d-flex justify-content-between gap-2">
                                  <span className="w-50">
                                    {" "}
                                    Active Workflows{" "}
                                  </span>{" "}
                                  <span className="w-50">
                                    {" "}
                                    {MachineDetails?.dataList2[0]
                                      ?.activeworkflows
                                      ? commonservices.NumberCalculateValue(
                                        MachineDetails?.dataList2[0]
                                          ?.activeworkflows
                                      )
                                      : " 0 "}
                                  </span>
                                </p>
                                <p className="mb-1 d-flex justify-content-between gap-2">
                                  <span className="w-50"> Success Rate </span>{" "}
                                  <span
                                    // className="w-50 green-color-text"
                                    className={`w-50 ${MachineDetails?.dataList2[0]?.successrate
                                      ? "green-color-text"
                                      : ""
                                      }`}
                                  // className="w-50 green-color-text"
                                  >
                                    {" "}
                                    {MachineDetails?.dataList2[0]?.successrate
                                      ? MachineDetails?.dataList2[0]
                                        ?.successrate + "%"
                                      : " N/A "}{" "}
                                  </span>
                                </p>
                                <p className="d-flex justify-content-between gap-2">
                                  <span className="w-50">
                                    {" "}
                                    Last Used in Workflow{" "}
                                  </span>{" "}
                                  <span className="w-50">
                                    {" "}
                                    {MachineDetails?.dataList2[0]
                                      ?.lastusedinworkflowon
                                      ? commonservices.getDateInFormatCustom(
                                        MachineDetails?.dataList2[0]
                                          ?.lastusedinworkflowon,
                                        null,
                                        "MM/DD/yyyy"
                                      )
                                      : " N/A "}{" "}
                                  </span>
                                </p>
                              </div>
                              <div className="single-informations-main">
                                <h5>Categories</h5>
                                <div className="all-badges-info">
                                  <span className="grey-badge">
                                    {MachineDetails?.dataList1[0]?.categoryname}
                                  </span>
                                </div>
                              </div>
                              <div className="single-informations-main">
                                <h5>Legal</h5>
                                {/* {MachineDetails?.dataList1[0]?.termsandcondition ? ( */}
                                <p
                                  className="theme-color-text mb-1 d-flex justify-content-between cursor-pointer gap-1"
                                  onClick={() => HandlePrivacyAndTerms("Terms")}
                                >
                                  Terms and Conditions
                                </p>
                                {/* ) : (
                             <Link className="theme-color-text text-decoration-none">
                              -
                             </Link>
                           )} */}
                                {/* {MachineDetails?.dataList1[0]?.privacypolicy ? ( */}
                                <p
                                  className="theme-color-text mb-1 d-flex justify-content-between cursor-pointer gap-1"
                                  onClick={() =>
                                    HandlePrivacyAndTerms("Privacy")
                                  }
                                >
                                  Privacy Policy
                                </p>
                                {/* ) : (
                            <Link className="theme-color-text text-decoration-none">
                              -
                            </Link>
                          )} */}
                              </div>
                              <div className="single-informations-main">
                                <h5>Contact</h5>
                                <Link
                                  to={`tel:${MachineDetails?.dataList1[0]?.contactno2}`}
                                  className="call-email"
                                >
                                  <img src={call} alt="call" />
                                  <span>
                                    {MachineDetails?.dataList1[0]?.contactno2
                                      ? MachineDetails?.dataList1[0]?.contactno2
                                      : " N/A "}
                                  </span>
                                </Link>
                                <Link
                                  to={`mailto:${MachineDetails?.dataList1[0]?.supportemail}`}
                                  className="call-email"
                                >
                                  <img src={email} alt="email" />
                                  <span>
                                    {MachineDetails?.dataList1[0]?.supportemail
                                      ? MachineDetails?.dataList1[0]
                                        ?.supportemail
                                      : " N/A "}
                                  </span>
                                </Link>
                              </div>
                              <div className="single-informations-main">
                                <h5>Support</h5>
                                {/* {MachineDetails?.dataList2[0]?.supportemail ? (
                          <a
                            href={
                              MachineDetails?.dataList2[0]?.supportemail
                                ? MachineDetails?.dataList2[0]?.supportemail
                                : "-"
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="theme-color-text"
                          ></a>
                        ) : (
                          <span className="theme-color-text text-decoration-none">
                            -
                          </span>
                        )} */}
                                {MachineDetails?.dataList1?.[0]
                                  ?.supporthours ? (
                                  <p>
                                    Average Response Time{" "}
                                    {
                                      MachineDetails?.dataList1?.[0]
                                        ?.supporthours
                                    }{" "}
                                    {/* hours */}
                                  </p>
                                ) : (
                                  <p>-</p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
            </Container>
          </div>
          {MachineVersionModalShow && (
            <MachineVersionModal
              machineversionlist={MachineVersionList}
              show={MachineVersionModalShow}
              onHide={(e) => setMachineVersionModalShow(false)}
            />
          )}
          {MachineModalShow && (
            <MachineModal
              data={MachineModaldata}
              type={MachineModalType}
              show={MachineModalShow}
              machineDetail={machineDetailRef.current}
              bindlist={getMachineVersions}
              onHide={(e) => setMachineModalShow(false)}
            />
          )}
          {showInputDetailPopup && (
            <Overlay
              ref={overlayDesc_Ref}
              target={targetInputDetail.current}
              show={handleShowInputDetailPopup}
              placement="bottom"
            >
              <Tooltip id="overlay-example">
                <InputDetail
                  handleshowPopup={handleShowInputDetailPopup}
                  compObj={paraDetailRef.current}
                />
              </Tooltip>
            </Overlay>
          )}
          {showFaqModal && (
            <FAQEditMarketplaceModal
              machinedata={MachineDetails}
              type={Faqtype}
              versionlist={VersionState}
              allfaqdata={FAQList}
              bindlist={getFAQList}
              bindlist1={getEditMachineData}
              updatemachinedetail={getMachineDetails}
              selecteddata={FAQEditAddSelectedData}
              show={showFaqModal}
              updatereviewstatus={updateReviewStatus}
              updatereviewcommentdata={UpdateReviewCommentData}
              geteditstatus={getEditStatus}
              setfaqdata={setFAQList}
              setversionstate={setVersionState}
              onHide={() => setShowFaqModal(false)}
            />
          )}
          {RejectDetailModalShow && (
            <CommentModal
              data={RejectDetailModaldata}
              show={RejectDetailModalShow}
              onHide={() => setRejectDetailModalShow(false)}
            />
          )}
          {ParameterEditAddMachineModalShow && (
            <ParameterEditMarketplaceModal
              machinedata={MachineDetails}
              type={ParameterEditAddMachineModaltype}
              show={ParameterEditAddMachineModalShow}
              selecteddata={ParameterEditAddSelectedData}
              bindlist={getMachineDetails}
              updatereviewstatus={updateReviewStatus}
              updatemachinedetail={getMachineDetails}
              updatereviewcommentdata={UpdateReviewCommentData}
              geteditstatus={getEditStatus}
              versionlist={VersionState}
              setmachinedetails={setMachineDetails}
              onHide={(e) => setParameterEditAddMachineModalShow(false)}
            />
          )}
          {TandCShow && (
            <SubscriberTermsAndCondition
              show={TandCShow}
              onsubmit={fnPurchase}
              loader={PurchaseLoader}
              subscriberId={
                MachineDetails?.dataList1?.[0]?.subscriberid
                  ? MachineDetails?.dataList1?.[0]?.subscriberid
                  : 0
              }
              // verifytext={setVerifymailText}
              onHide={() => setTandCShow(false)}
            />
          )}
          {addToCartShow && (
            <AddToCartForAI
              show={addToCartShow}
              // onsubmit={fnPurchase}
              loader={PurchaseLoader}
              subscriberId={
                MachineDetails?.dataList1?.[0]?.subscriberid
                  ? MachineDetails?.dataList1?.[0]?.subscriberid
                  : 0
              }
              // verifytext={setVerifymailText}
              onHide={() => setAddToCartShow(false)}
              handlePlaceOrder={handlePlaceOrder}
              handleParentpopup={() => param.onHide()}
              endCall={param?.endCall}
            />
          )}
          {TermsAndPrivacyShow && (
            <TermsAndConditionInAll
              show={TermsAndPrivacyShow}
              // onsubmit={fnPurchase}
              // loader={PurchaseLoader}
              type={TermsAndPrivacyType}
              subscriberId={
                MachineDetails?.dataList1?.[0]?.subscriberid
                  ? MachineDetails?.dataList1?.[0]?.subscriberid
                  : 0
              }
              // verifytext={setVerifymailText}
              onHide={() => setTermsAndPrivacyShow(false)}
            />
          )}
          {showReviewModal && (
            <WriteReviewModal
              show={showReviewModal}
              handleClose={closeReviewModal}
              payload={{
                machineid: MachineDetails?.dataList1?.[0]?.machineid,
                refmachineid: MachineDetails?.dataList1?.[0]?.refmachineid,
              }}
              getMachineDetail={getMachineDetails}
            />
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default MarketPlaceDetailPopup;
